export const reviewArrow = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 11 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.14835 8.95225C0.679718 9.42088 0.679718 10.1807 1.14835 10.6493L8.7851 18.2861C9.25373 18.7547 10.0135 18.7547 10.4822 18.2861C10.9508 17.8174 10.9508 17.0576 10.4822 16.589L3.69393 9.80078L10.4822 3.01256C10.9508 2.54393 10.9508 1.78413 10.4822 1.3155C10.0135 0.84687 9.25373 0.84687 8.7851 1.3155L1.14835 8.95225ZM3.79688 8.60078H1.99688L1.99688 11.0008H3.79688V8.60078Z"
      fill="white"
    />
  </svg>
);

export const playIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <path d="M10.4546 6L1.54688 12V0L10.4546 6Z" fill="#D4D8DE" />
  </svg>
);

export const pauseIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <path d="M0.5 0H4.5V12H0.5V0Z" fill="#D4D8DE" />
    <path d="M7.5 0H11.5V12H7.5V0Z" fill="#D4D8DE" />
  </svg>
);

export const reviewBarMobile = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 708 353"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_3824_717)">
      <path d="M0 96H325V274.5L238 348H0V96Z" fill="#202020" />
    </g>
    <g filter="url(#filter1_di_3824_717)">
      <path
        d="M-0.5 0.5H708V275.5H323.5L219 102.5H-0.5V0.5Z"
        fill="url(#paint0_linear_3824_717)"
      />
      <path
        d="M-0.5 0.5H708V275.5H323.5L219 102.5H-0.5V0.5Z"
        fill="#020202"
        fillOpacity="0.1"
      />
      <path
        d="M-0.5 0.5H708V275.5H323.5L219 102.5H-0.5V0.5Z"
        fill="url(#paint1_linear_3824_717)"
        fillOpacity="0.4"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_3824_717"
        x="-2.5"
        y="95.5"
        width="330"
        height="257"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="1.25" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3824_717"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3824_717"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_di_3824_717"
        x="-3.1"
        y="0.5"
        width="713.7"
        height="280.2"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2.6" />
        <feGaussianBlur stdDeviation="1.3" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3824_717"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3824_717"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.3" />
        <feGaussianBlur stdDeviation="0.325" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_3824_717"
        />
      </filter>
      <linearGradient
        id="paint0_linear_3824_717"
        x1="-43.6523"
        y1="-44.1947"
        x2="985.53"
        y2="-45.5758"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#292B30" />
        <stop offset="0.518171" stopColor="#3B3F47" />
        <stop offset="1" stopColor="#262626" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3824_717"
        x1="767.5"
        y1="-63.2499"
        x2="567"
        y2="222"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B9B9B9" />
        <stop offset="1" stopColor="#5B5B5B" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export const reviewBar = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1703 441"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_3776_12160)">
      <rect x="-1" y="111" width="1075" height="249" fill="#202020" />
    </g>
    <g filter="url(#filter1_di_3776_12160)">
      <path
        d="M0 0H1703V430H1079.5L848 147.5H0V0Z"
        fill="url(#paint0_linear_3776_12160)"
      />
      <path
        d="M0 0H1703V430H1079.5L848 147.5H0V0Z"
        fill="#020202"
        fillOpacity="0.1"
      />
      <path
        d="M0 0H1703V430H1079.5L848 147.5H0V0Z"
        fill="url(#paint1_linear_3776_12160)"
        fillOpacity="0.4"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_3776_12160"
        x="-6"
        y="110"
        width="1085"
        height="259"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3776_12160"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3776_12160"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_di_3776_12160"
        x="-5.2"
        y="0"
        width="1713.4"
        height="440.4"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="5.2" />
        <feGaussianBlur stdDeviation="2.6" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3776_12160"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3776_12160"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2.6" />
        <feGaussianBlur stdDeviation="0.65" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_3776_12160"
        />
      </filter>
      <linearGradient
        id="paint0_linear_3776_12160"
        x1="22.6954"
        y1="-89.3898"
        x2="2081.06"
        y2="-92.1521"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#292B30" />
        <stop offset="0.518171" stopColor="#3B3F47" />
        <stop offset="1" stopColor="#262626" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3776_12160"
        x1="1645"
        y1="-127.501"
        x2="1244"
        y2="442.999"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B9B9B9" />
        <stop offset="1" stopColor="#5B5B5B" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export const bulletCoin = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 68 69"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M65.6425 34.4282C65.6425 52.0872 51.3271 66.4026 33.6682 66.4026C16.0094 66.4026 1.694 52.0872 1.694 34.4282C1.694 16.7692 16.0094 2.45377 33.6682 2.45377C51.3271 2.45377 65.6425 16.7692 65.6425 34.4282ZM33.88 60.4736C48.1474 60.4736 59.7135 48.9075 59.7135 34.6399C59.7135 20.3724 48.1474 8.80631 33.88 8.80631C19.6125 8.80631 8.0465 20.3724 8.0465 34.6399C8.0465 48.9075 19.6125 60.4736 33.88 60.4736Z"
      fill="#373737"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M67.76 34.6399C67.76 53.3515 52.5914 68.5201 33.88 68.5201C15.1686 68.5201 0 53.3515 0 34.6399C0 15.9284 15.1686 0.759766 33.88 0.759766C52.5914 0.759766 67.76 15.9284 67.76 34.6399ZM33.6682 66.4026C51.3271 66.4026 65.6425 52.0872 65.6425 34.4282C65.6425 16.7692 51.3271 2.45377 33.6682 2.45377C16.0094 2.45377 1.694 16.7692 1.694 34.4282C1.694 52.0872 16.0094 66.4026 33.6682 66.4026Z"
      fill="url(#paint0_linear_3715_36131)"
    />
    <path
      d="M55.8691 28.3652C54.5257 23.6567 51.7051 19.5 47.8185 16.5112C43.8343 13.4474 38.9517 11.7814 33.9257 11.7709C28.8996 11.7603 24.0101 13.4059 20.0131 16.453C16.114 19.4255 13.276 23.5703 11.9129 28.2731C11.8562 28.4689 11.9724 28.6719 12.1691 28.7255C12.3657 28.7791 12.5683 28.6629 12.6252 28.4672C13.9456 23.9208 16.6905 19.9141 20.4606 17.04C24.3286 14.0912 29.0603 12.4988 33.9241 12.509C38.7879 12.5192 43.513 14.1314 47.3686 17.0964C51.1266 19.9863 53.8547 24.0044 55.1561 28.5563C55.2121 28.7523 55.4142 28.8693 55.611 28.8165C55.8079 28.7638 55.925 28.5612 55.8691 28.3652Z"
      fill="url(#paint1_linear_3715_36131)"
    />
    <path
      d="M55.8691 40.914C54.5257 45.6225 51.7051 49.7791 47.8185 52.7679C43.8343 55.8318 38.9517 57.4978 33.9257 57.5083C28.8996 57.5188 24.0101 55.8733 20.0131 52.8262C16.114 49.8537 13.276 45.7089 11.9129 41.006C11.8562 40.8103 11.9724 40.6072 12.1691 40.5537C12.3657 40.5001 12.5683 40.6162 12.6252 40.812C13.9456 45.3583 16.6905 49.365 20.4606 52.2392C24.3286 55.188 29.0603 56.7804 33.9241 56.7702C38.7879 56.76 43.5129 55.1478 47.3686 52.1828C51.1266 49.2929 53.8547 45.2748 55.1561 40.7229C55.2121 40.5269 55.4142 40.4099 55.611 40.4627C55.8079 40.5154 55.925 40.718 55.8691 40.914Z"
      fill="url(#paint2_linear_3715_36131)"
    />
    <path
      d="M27.4779 26.2174H24.0155C23.984 26.2174 23.955 26.2343 23.9395 26.2618L16.479 39.5103C16.4486 39.5644 16.4501 39.6307 16.483 39.6833L18.335 42.6462C18.351 42.6716 18.3789 42.6871 18.409 42.6871H27.6424C27.6739 42.6871 27.7029 42.6702 27.7184 42.6429L35.1255 29.5662C35.1494 29.524 35.1472 29.4718 35.1198 29.4318L33.1945 26.6183C33.1413 26.5406 33.0251 26.5457 32.9789 26.6277L25.7359 39.4901C25.6983 39.5567 25.6278 39.598 25.5514 39.598H20.3701C20.2076 39.598 20.1057 39.4226 20.1861 39.2814L27.5537 26.3475C27.5868 26.2894 27.5448 26.2174 27.4779 26.2174Z"
      fill="url(#paint3_linear_3715_36131)"
    />
    <path
      d="M37.8762 42.571C37.9078 42.571 37.9368 42.5541 37.9523 42.5266L43.4874 32.6971H39.8823L34.3952 42.4413C34.3625 42.4993 34.4045 42.571 34.4712 42.571H37.8762Z"
      fill="url(#paint4_linear_3715_36131)"
    />
    <path
      d="M36.1602 29.4972L41.7226 29.429L43.4874 32.6971L45.3528 29.3846L49.1879 29.3376L50.8719 26.3471C50.9046 26.2891 50.8625 26.2174 50.7958 26.2174H38.0582C38.0266 26.2174 37.9976 26.2343 37.9821 26.2618L36.1602 29.4972Z"
      fill="url(#paint5_linear_3715_36131)"
    />
    <path
      d="M52.8828 34.6815L56.8849 32.3709V36.9922L52.8828 34.6815Z"
      fill="url(#paint6_linear_3715_36131)"
    />
    <path
      d="M14.4844 34.6815L10.4823 32.3709V36.9922L14.4844 34.6815Z"
      fill="url(#paint7_linear_3715_36131)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3715_36131"
        x1="14.4844"
        y1="34.6815"
        x2="9.14828"
        y2="34.6815"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3715_36131"
        x1="14.4844"
        y1="34.6815"
        x2="9.14828"
        y2="34.6815"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3715_36131"
        x1="14.4844"
        y1="34.6815"
        x2="9.14828"
        y2="34.6815"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3715_36131"
        x1="14.4844"
        y1="34.6815"
        x2="9.14828"
        y2="34.6815"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_3715_36131"
        x1="14.4844"
        y1="34.6815"
        x2="9.14828"
        y2="34.6815"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_3715_36131"
        x1="14.4844"
        y1="34.6815"
        x2="9.14828"
        y2="34.6815"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_3715_36131"
        x1="14.4844"
        y1="34.6815"
        x2="9.14828"
        y2="34.6815"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_3715_36131"
        x1="14.4844"
        y1="34.6815"
        x2="9.14828"
        y2="34.6815"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
    </defs>
  </svg>
);

export const sbcIcon = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 68 68"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M67.76 33.8802C67.76 52.5917 52.5914 67.7604 33.88 67.7604C15.1686 67.7604 0 52.5917 0 33.8802C0 15.1687 15.1686 0 33.88 0C52.5914 0 67.76 15.1687 67.76 33.8802ZM33.88 66.0664C51.6558 66.0664 66.066 51.6561 66.066 33.8802C66.066 16.1042 51.6558 1.69401 33.88 1.69401C16.1042 1.69401 1.694 16.1042 1.694 33.8802C1.694 51.6561 16.1042 66.0664 33.88 66.0664Z"
      fill="url(#paint0_linear_3713_19827)"
    />
    <path
      d="M33.88 12.1969C21.9047 12.1969 12.1968 21.9048 12.1968 33.8802C12.1968 35.0918 12.2962 36.2801 12.4872 37.4376C13.9798 36.5797 14.8058 36.157 16.2624 35.7436C16.2624 35.7436 16.6012 34.8966 16.94 34.7272C17.2788 34.5578 17.4482 34.5578 17.4482 34.5578C17.4482 34.5578 17.4959 33.6267 17.4482 33.0332C17.389 32.2959 17.1094 31.1698 17.1094 31.1698C17.1094 31.1698 16.7706 31.3392 16.4318 31.1698C16.093 31.0004 15.4154 28.29 15.5848 27.9512C15.7542 27.6123 16.093 27.7817 16.093 27.7817C15.6766 24.4057 16.4318 22.8691 18.634 21.5139C18.634 21.5139 19.1022 21.3445 19.481 21.3445C19.657 21.3445 19.7827 21.3045 19.9128 21.263C20.0331 21.2247 20.1571 21.1852 20.328 21.1751C20.5788 21.1604 20.7452 21.2057 20.928 21.2555C21.0497 21.2887 21.1785 21.3238 21.3444 21.3445C21.6382 21.3812 21.8856 21.2922 22.1211 21.2075C22.4222 21.0991 22.704 20.9978 23.0384 21.1751C23.2921 21.3096 23.382 21.4294 23.5025 21.5901L23.5244 21.6192C23.5763 21.688 23.6355 21.7646 23.716 21.8527C24.0184 22.1839 24.4562 22.4689 24.8314 22.7132C25.243 22.9811 25.5794 23.2001 25.5794 23.3773C25.5794 23.5739 25.4551 23.6903 25.3292 23.808C25.2082 23.9212 25.0857 24.0358 25.0712 24.2243C24.9018 26.4265 26.4264 29.137 26.5958 29.3064C26.7652 29.4758 26.257 30.6616 25.9182 31.0004C25.5794 31.3392 25.2406 31.1698 25.2406 31.1698C25.2406 31.1698 24.9503 32.3992 24.9018 33.2026C24.8739 33.6648 24.9018 34.3884 24.9018 34.3884C24.9018 34.3884 25.5794 34.5578 25.41 34.7272C25.3253 34.8119 23.6313 35.6589 21.7255 36.6118C19.8198 37.5647 17.7023 38.6234 16.7706 39.1316C14.9072 40.148 14.0602 42.6877 14.0602 42.6877C14.2133 43.0318 14.3751 43.3711 14.5454 43.7054C14.5454 43.7054 15.246 41.6726 16.6012 40.3174C17.5777 39.3409 22.1601 37.309 24.8351 36.1229C25.8726 35.6629 26.6232 35.3301 26.7652 35.2354C27.2734 34.8966 28.6286 33.5414 28.6286 33.372V31.5086C28.6286 31.5086 28.2898 28.7982 28.1204 28.7982C28.0483 28.7982 27.981 28.8422 27.9123 28.8871C27.8197 28.9476 27.7247 29.0097 27.6122 28.9676C26.257 28.4594 25.7488 24.5631 26.0876 24.0549C26.2344 23.8348 26.7652 24.0549 26.7652 24.0549C26.4544 19.7229 27.0256 17.8541 29.4756 15.9237C29.4756 15.9237 30.1532 15.2461 31.1696 15.0767C31.6943 14.9892 31.9452 14.8706 32.1599 14.7691C32.3611 14.6739 32.5304 14.5938 32.8636 14.5685C33.1865 14.5439 33.4307 14.5948 33.6816 14.6471C33.8949 14.6915 34.1129 14.7369 34.3882 14.7379C34.9256 14.7397 35.5099 14.6101 35.9581 14.5106C36.2356 14.4491 36.4608 14.3991 36.5904 14.3991C36.9292 14.3991 37.4374 15.4155 37.4374 15.4155C40.9948 17.6177 41.1642 19.6505 41.1642 23.8855C41.1642 23.8855 41.503 23.8855 41.8418 24.2243C42.1806 24.5631 41.1642 28.6288 40.656 28.7982C40.1478 28.9676 39.809 28.7982 39.809 28.7982C39.809 28.7982 39.2191 30.6698 39.1314 31.678C39.0626 32.4688 39.3008 33.372 39.3008 33.372C39.3008 33.372 39.6396 33.372 39.809 33.5414C39.8638 33.5962 39.9897 33.7754 40.1464 33.9983C40.4736 34.464 40.9351 35.1208 41.1642 35.2354C41.1997 35.2531 41.3299 35.3173 41.5358 35.4188C43.296 36.2863 50.5876 39.8802 51.4976 40.4868C52.514 41.1644 53.2999 43.536 53.2999 43.536C53.4663 43.202 53.6243 42.8631 53.7737 42.5196C53.7737 42.5196 53.5304 41.1644 52.1752 39.8092C51.2606 38.8946 47.1058 36.9771 44.5006 35.7748C43.2454 35.1955 42.35 34.7823 42.35 34.7272C42.35 34.6425 42.5194 34.6001 42.6888 34.5578C42.8582 34.5154 43.0276 34.4731 43.0276 34.3884C43.0276 34.348 43.0309 34.2797 43.0351 34.192C43.0486 33.9119 43.0717 33.4338 43.0276 33.0332C42.9451 32.2834 42.6888 31.1698 42.6888 31.1698C42.6888 31.1698 42.1806 31.3392 41.8418 31.0004C41.503 30.6616 41.1642 29.3064 41.1642 29.3064C41.1642 29.3064 42.8582 26.4265 42.8582 25.0713C42.8582 23.7161 42.1806 23.3773 42.1806 23.3773C42.1806 23.3773 43.1905 22.1719 44.044 21.6833C44.716 21.2987 45.9074 21.0057 45.9074 21.0057C46.6684 21.1614 47.5374 21.0817 48.0625 21.0335C48.232 21.018 48.3657 21.0057 48.4484 21.0057C48.5729 21.0057 48.6288 21.0743 48.7337 21.2031C48.9143 21.4249 49.2402 21.8251 50.3118 22.3609C52.0058 23.2079 51.8364 27.7817 51.8364 27.7817C51.8364 27.7817 52.3446 27.7817 52.514 28.1206C52.6834 28.4594 51.667 31.0004 51.3282 31.1698C50.9894 31.3392 50.82 31.1698 50.82 31.1698C50.82 31.1698 50.5297 32.3992 50.4812 33.2026C50.4533 33.6648 50.4812 34.3884 50.4812 34.3884C50.4812 34.3884 50.8037 34.5775 50.9894 34.7272C51.1562 34.8617 51.3091 35.0488 51.4639 35.2382C51.6824 35.5057 51.9047 35.7777 52.1752 35.913C53.5304 36.5906 55.3001 37.2682 55.3001 37.2682C55.4733 36.1643 55.5632 35.0327 55.5632 33.8802C55.5632 21.9048 45.8553 12.1969 33.88 12.1969Z"
      fill="url(#paint1_linear_3713_19827)"
    />
    <path
      d="M28.2898 34.5578C28.1204 34.7272 27.4559 35.6527 27.6122 35.913C29.7316 39.3698 30.8956 40.1603 33.2089 41.7314L33.3718 41.842L34.0494 42.1808L34.5576 41.842C37.2991 39.7594 39.6396 37.4376 40.3172 35.7436C40.4205 35.3205 40.2148 35.12 39.8236 34.7387C39.7661 34.6827 39.7047 34.6229 39.6396 34.5578C39.6396 34.5578 39.4702 34.3884 39.6396 35.4048C39.809 36.4212 34.5576 40.6562 34.0494 40.6562C33.5412 40.6562 28.2898 35.5742 28.2898 35.5742C28.2898 35.5742 28.4592 34.3884 28.2898 34.5578Z"
      fill="url(#paint2_linear_3713_19827)"
    />
    <path
      d="M17.6176 45.9076C17.6176 45.9076 18.8034 47.0935 19.481 47.2629C20.1586 47.4323 21.3444 46.9241 21.175 45.7382C21.0056 44.5524 20.328 43.8748 20.328 43.8748C19.844 44.7671 19.8369 45.2817 19.9892 46.2464C19.0453 45.5088 18.571 45.4726 17.6176 45.9076Z"
      fill="url(#paint3_linear_3713_19827)"
    />
    <path
      d="M19.8198 48.2793C20.6817 47.8597 21.2248 47.7961 22.3608 48.4487C21.4747 47.2751 21.5483 46.6957 22.022 45.7382C22.022 45.7382 22.6996 46.5853 23.0384 47.4323C23.3772 48.2793 23.0384 49.1263 22.022 49.2957C21.0056 49.4651 19.8198 48.2793 19.8198 48.2793Z"
      fill="url(#paint4_linear_3713_19827)"
    />
    <path
      d="M24.0548 47.2629C24.0548 47.2629 25.2406 47.9405 25.5794 49.1263C25.9182 50.3121 25.0712 50.8203 24.2242 50.8203C23.3772 50.8203 22.1914 50.1427 22.1914 50.1427C23.1044 49.4567 23.692 49.395 24.9018 49.9733C23.8753 48.8667 23.9392 48.2963 24.0503 47.3029L24.0548 47.2629Z"
      fill="url(#paint5_linear_3713_19827)"
    />
    <path
      d="M25.0712 52.0061C25.7964 51.2497 26.2813 51.0225 27.4428 51.1591C26.3798 50.3716 26.3041 49.8091 26.257 48.7875C26.257 48.7875 27.4428 48.9569 27.951 49.9733C28.4592 50.9897 28.1204 52.0061 27.104 52.3449C26.0876 52.6837 25.0712 52.0061 25.0712 52.0061Z"
      fill="url(#paint6_linear_3713_19827)"
    />
    <path
      d="M28.1204 53.0225C28.7617 52.11 29.2287 51.7845 30.492 51.8367C29.319 51.2175 28.8219 50.7919 28.798 49.6345C28.798 49.6345 30.1532 49.9733 30.6614 50.6509C31.1696 51.3285 31.1696 51.6673 31.1696 51.6673C32.2028 51.9161 33.0015 52.1778 33.7738 52.5076C34.6702 52.0953 35.5558 51.7878 36.7598 51.4979C36.7598 51.4979 36.7598 51.1591 37.268 50.4815C37.7762 49.8039 39.1314 49.4651 39.1314 49.4651C39.1075 50.6225 38.6104 51.0481 37.4374 51.6673C38.7007 51.6151 39.1677 51.9406 39.809 52.8531C39.809 52.8531 38.4538 53.1919 37.7762 52.8531C37.0986 52.5143 36.9292 52.0061 36.9292 52.0061C35.8776 52.2308 35.0985 52.4677 34.3977 52.7907C35.0173 53.0876 35.656 53.4378 36.421 53.8695L35.7434 54.3777C35.038 53.8256 34.4452 53.4175 33.8066 53.0932C33.2835 53.3881 32.7738 53.7482 32.186 54.2083L31.5084 53.7001C32.1239 53.3527 32.6576 53.0582 33.1655 52.8017C32.5573 52.5564 31.8724 52.3619 31.0002 52.1755C31.0002 52.1755 30.8308 52.6837 30.1532 53.0225C29.4756 53.3613 28.1204 53.0225 28.1204 53.0225Z"
      fill="url(#paint7_linear_3713_19827)"
    />
    <path
      d="M42.8582 51.8367C42.133 51.0803 41.6481 50.8531 40.4866 50.9897C41.5496 50.2022 41.6253 49.6397 41.6724 48.6181C41.6724 48.6181 40.4866 48.7875 39.9784 49.8039C39.4702 50.8203 39.809 51.8367 40.8254 52.1755C41.8418 52.5143 42.8582 51.8367 42.8582 51.8367Z"
      fill="url(#paint8_linear_3713_19827)"
    />
    <path
      d="M43.8746 47.0935C43.8746 47.0935 42.6888 47.7711 42.35 48.9569C42.0112 50.1427 42.8582 50.6509 43.7052 50.6509C44.5522 50.6509 45.738 49.9733 45.738 49.9733C44.825 49.2873 44.2373 49.2256 43.0276 49.8039C44.0541 48.6973 43.9902 48.1269 43.8791 47.1335L43.8746 47.0935Z"
      fill="url(#paint9_linear_3713_19827)"
    />
    <path
      d="M48.1096 48.1099C47.2477 47.6903 46.7046 47.6267 45.5686 48.2793C46.4547 47.1057 46.3811 46.5263 45.9074 45.5688C45.9074 45.5688 45.2298 46.4159 44.891 47.2629C44.5522 48.1099 44.891 48.9569 45.9074 49.1263C46.9238 49.2957 48.1096 48.1099 48.1096 48.1099Z"
      fill="url(#paint10_linear_3713_19827)"
    />
    <path
      d="M50.3118 45.7382C50.3118 45.7382 49.126 46.9241 48.4484 47.0935C47.7708 47.2629 46.585 46.7547 46.7544 45.5688C46.9238 44.383 47.6014 43.7054 47.6014 43.7054C48.0854 44.5977 48.0925 45.1123 47.9402 46.077C48.8841 45.3394 49.3584 45.3032 50.3118 45.7382Z"
      fill="url(#paint11_linear_3713_19827)"
    />
    <path
      d="M46.0676 9.67091C51.3736 12.342 55.6607 16.6858 58.2608 22.0394C60.949 27.5747 61.6738 33.86 60.3158 39.8618C58.9578 45.8637 55.5979 51.2248 50.7886 55.0636C45.9793 58.9025 40.0069 60.9905 33.8533 60.9845C27.6998 60.9784 21.7315 58.8786 16.9298 55.0303C12.128 51.182 8.77872 45.8143 7.43255 39.8098C6.08638 33.8053 6.82348 27.5214 9.52266 21.9914C12.1332 16.6429 16.4289 12.3076 21.7402 9.64696C22.0391 9.49723 22.4003 9.62685 22.5433 9.92901C22.6863 10.2312 22.5569 10.5914 22.2582 10.7415C17.1953 13.2843 13.1006 17.421 10.6106 22.5224C8.03196 27.8054 7.32778 33.8086 8.61383 39.5449C9.89987 45.2813 13.0996 50.4092 17.6869 54.0856C22.2741 57.7621 27.9759 59.7681 33.8545 59.7739C39.7332 59.7797 45.4389 57.7849 50.0334 54.1175C54.6279 50.4501 57.8377 45.3284 59.135 39.5947C60.4324 33.8609 59.74 27.8563 57.1718 22.5683C54.6918 17.4619 50.6052 13.3172 45.5474 10.7644C45.249 10.6138 45.1203 10.2533 45.2639 9.95138C45.4075 9.6495 45.769 9.52059 46.0676 9.67091Z"
      fill="url(#paint12_linear_3713_19827)"
    />
    <path
      d="M41.3336 5.75963L41.9421 7.63248H43.9113L42.3182 8.78997L42.9267 10.6628L41.3336 9.50533L39.7405 10.6628L40.349 8.78997L38.7559 7.63248H40.7251L41.3336 5.75963Z"
      fill="url(#paint13_linear_3713_19827)"
    />
    <path
      d="M33.88 3.04922L34.7547 5.74144H37.5855L35.2954 7.40532L36.1701 10.0975L33.88 8.43366L31.5899 10.0975L32.4646 7.40532L30.1745 5.74144H33.0052L33.88 3.04922Z"
      fill="url(#paint14_linear_3713_19827)"
    />
    <path
      d="M26.4264 5.75963L27.0349 7.63248H29.0041L27.411 8.78997L28.0195 10.6628L26.4264 9.50533L24.8333 10.6628L25.4418 8.78997L23.8487 7.63248H25.8179L26.4264 5.75963Z"
      fill="url(#paint15_linear_3713_19827)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3713_19827"
        x1="33.88"
        y1="0"
        x2="33.88"
        y2="67.7604"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3713_19827"
        x1="33.88"
        y1="0"
        x2="33.88"
        y2="67.7604"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3713_19827"
        x1="33.88"
        y1="0"
        x2="33.88"
        y2="67.7604"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3713_19827"
        x1="33.88"
        y1="0"
        x2="33.88"
        y2="67.7604"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_3713_19827"
        x1="33.88"
        y1="0"
        x2="33.88"
        y2="67.7604"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_3713_19827"
        x1="33.88"
        y1="0"
        x2="33.88"
        y2="67.7604"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_3713_19827"
        x1="33.88"
        y1="0"
        x2="33.88"
        y2="67.7604"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_3713_19827"
        x1="33.88"
        y1="0"
        x2="33.88"
        y2="67.7604"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_3713_19827"
        x1="33.88"
        y1="0"
        x2="33.88"
        y2="67.7604"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_3713_19827"
        x1="33.88"
        y1="0"
        x2="33.88"
        y2="67.7604"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_3713_19827"
        x1="33.88"
        y1="0"
        x2="33.88"
        y2="67.7604"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_3713_19827"
        x1="33.88"
        y1="0"
        x2="33.88"
        y2="67.7604"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_3713_19827"
        x1="33.88"
        y1="0"
        x2="33.88"
        y2="67.7604"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_3713_19827"
        x1="33.88"
        y1="0"
        x2="33.88"
        y2="67.7604"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_3713_19827"
        x1="33.88"
        y1="0"
        x2="33.88"
        y2="67.7604"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_3713_19827"
        x1="33.88"
        y1="0"
        x2="33.88"
        y2="67.7604"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
    </defs>
  </svg>
);

export const buildSquadIcon = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 68 69"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M67.76 34.6399C67.76 53.3515 52.5914 68.5201 33.88 68.5201C15.1686 68.5201 0 53.3515 0 34.6399C0 15.9284 15.1686 0.759766 33.88 0.759766C52.5914 0.759766 67.76 15.9284 67.76 34.6399ZM3.72052 34.6399C3.72052 51.2967 17.2234 64.7996 33.88 64.7996C50.5366 64.7996 64.0395 51.2967 64.0395 34.6399C64.0395 17.9832 50.5366 4.48031 33.88 4.48031C17.2234 4.48031 3.72052 17.9832 3.72052 34.6399Z"
      fill="#373737"
    />
    <path
      d="M67.76 34.6399C67.76 53.3515 52.5914 68.5201 33.88 68.5201C15.1686 68.5201 0 53.3515 0 34.6399C0 15.9284 15.1686 0.759766 33.88 0.759766C52.5914 0.759766 67.76 15.9284 67.76 34.6399ZM1.55316 34.6399C1.55316 52.4937 16.0264 66.967 33.88 66.967C51.7336 66.967 66.2068 52.4937 66.2068 34.6399C66.2068 16.7862 51.7336 2.31293 33.88 2.31293C16.0264 2.31293 1.55316 16.7862 1.55316 34.6399Z"
      fill="url(#paint0_linear_3713_19831)"
    />
    <rect
      width="16.4653"
      height="16.4653"
      transform="matrix(0.707039 -0.707175 0.707039 0.707175 24.1875 24.9922)"
      fill="#373737"
    />
    <rect
      width="16.4653"
      height="16.4653"
      transform="matrix(0.707039 -0.707175 0.707039 0.707175 39.7266 40.4883)"
      fill="#373737"
    />
    <rect
      width="16.4653"
      height="16.4653"
      transform="matrix(0.707039 -0.707175 0.707039 0.707175 8.70312 40.4805)"
      fill="#373737"
    />
    <rect
      width="16.4653"
      height="16.4653"
      transform="matrix(0.707039 -0.707175 0.707039 0.707175 22.25 23.0566)"
      fill="url(#paint1_linear_3713_19831)"
    />
    <rect
      width="16.4653"
      height="16.4653"
      transform="matrix(0.707039 -0.707175 0.707039 0.707175 37.7891 38.5527)"
      fill="url(#paint2_linear_3713_19831)"
    />
    <rect
      width="16.4653"
      height="16.4653"
      transform="matrix(0.707039 -0.707175 0.707039 0.707175 6.76562 38.5449)"
      fill="url(#paint3_linear_3713_19831)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3713_19831"
        x1="33.88"
        y1="0.759766"
        x2="33.88"
        y2="68.5201"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3713_19831"
        x1="8.23267"
        y1="0"
        x2="8.23267"
        y2="16.4653"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3713_19831"
        x1="8.23267"
        y1="0"
        x2="8.23267"
        y2="16.4653"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3713_19831"
        x1="8.23267"
        y1="0"
        x2="8.23267"
        y2="16.4653"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#56D487" />
        <stop offset="1" stopColor="#12E9EB" />
      </linearGradient>
    </defs>
  </svg>
);

export const greenGlowBox = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 313 75"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_f_3655_3)">
      <rect
        x="6"
        y="6.99023"
        width="301"
        height="62"
        rx="14"
        stroke="#00FFCC"
        strokeWidth="4"
      />
    </g>
    <rect
      x="6"
      y="6.99023"
      width="301"
      height="62"
      rx="14"
      stroke="#68FFE5"
      strokeWidth="2"
    />
    <defs>
      <filter
        id="filter0_f_3655_3"
        x="0"
        y="0.990234"
        width="313"
        height="74"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="2"
          result="effect1_foregroundBlur_3655_3"
        />
      </filter>
    </defs>
  </svg>
);

export const orangeGlowBox = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 283 74"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_f_12_188)">
      <rect
        x="6"
        y="6"
        width="271"
        height="62"
        rx="14"
        stroke="#FF5900"
        strokeWidth="4"
      />
    </g>
    <rect
      x="6"
      y="6"
      width="271"
      height="62"
      rx="14"
      stroke="#FFA34E"
      strokeWidth="2"
    />
    <defs>
      <filter
        id="filter0_f_12_188"
        x="0"
        y="0"
        width="283"
        height="74"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="2"
          result="effect1_foregroundBlur_12_188"
        />
      </filter>
    </defs>
  </svg>
);

export const blueGlowBox = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 208 74"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_f_3655_2)">
      <rect
        x="6"
        y="6"
        width="196"
        height="62"
        rx="14"
        stroke="#12C9E9"
        strokeWidth="4"
      />
    </g>
    <rect
      x="6"
      y="6"
      width="196"
      height="62"
      rx="14"
      stroke="#ABF4FF"
      strokeWidth="2"
    />
    <defs>
      <filter
        id="filter0_f_3655_2"
        x="0"
        y="0"
        width="208"
        height="74"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="2"
          result="effect1_foregroundBlur_3655_2"
        />
      </filter>
    </defs>
  </svg>
);

export const importArrow = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 65 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M63.7678 20.7678C64.7441 19.7915 64.7441 18.2085 63.7678 17.2322L47.8579 1.32233C46.8816 0.34602 45.2986 0.34602 44.3223 1.32233C43.346 2.29864 43.346 3.88155 44.3223 4.85786L58.4645 19L44.3223 33.1421C43.346 34.1184 43.346 35.7014 44.3223 36.6777C45.2986 37.654 46.8816 37.654 47.8579 36.6777L63.7678 20.7678ZM-1.17735e-09 21.5L62 21.5L62 16.5L1.17735e-09 16.5L-1.17735e-09 21.5Z"
      fill="url(#paint0_linear_3081_9743)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3081_9743"
        x1="31"
        y1="19"
        x2="1.31915"
        y2="19"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1CFF00" />
        <stop offset="1" stopColor="#1CFF00" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export const eaToClubArrow = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 774 594"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_3399_20259)">
      <path
        d="M30.4241 34.3619C18.5403 37.9938 11.8509 50.5718 15.4828 62.4556C19.1147 74.3394 31.6927 81.0289 43.5765 77.3969L30.4241 34.3619ZM592.025 587.385C600.812 596.172 615.058 596.172 623.845 587.385L767.035 444.197C775.822 435.41 775.822 421.164 767.035 412.377C758.249 403.59 744.002 403.59 735.216 412.377L607.936 539.655L480.657 412.375C471.87 403.589 457.624 403.588 448.837 412.375C440.051 421.162 440.05 435.408 448.837 444.195L592.025 587.385ZM43.5765 77.3969C176.585 36.7467 311.387 67.2146 413.285 153.689C515.216 240.191 585.437 383.941 585.435 571.475L630.435 571.475C630.437 372.506 555.689 215.518 442.402 119.379C329.082 23.211 178.415 -10.8673 30.4241 34.3619L43.5765 77.3969Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_3399_20259"
        x="0.496094"
        y="0.59375"
        width="773.129"
        height="593.383"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-10" dy="-10" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.00392157 0 0 0 0 0.654902 0 0 0 0 0.803922 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3399_20259"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3399_20259"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const clubToSolutionArrow = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1037 773"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_3399_20261)">
      <path
        d="M1036.5 34.4208C1036.73 23.6537 1028.19 14.7385 1017.42 14.5082C1006.66 14.2779 997.742 22.8197 997.512 33.5868L1036.5 34.4208ZM22.7896 596.905C14.1773 603.371 12.4376 615.595 18.9039 624.207L124.277 764.552C130.743 773.164 142.967 774.904 151.579 768.438C160.192 761.971 161.931 749.748 155.465 741.136L61.7998 616.385L186.551 522.719C195.163 516.253 196.903 504.03 190.436 495.417C183.97 486.805 171.747 485.065 163.134 491.532L22.7896 596.905ZM997.512 33.5868C992.368 274.048 884.052 431.06 713.042 519.949C540.529 609.619 302.185 630.901 37.2453 593.193L31.75 631.804C300.813 670.098 548.433 649.464 731.029 554.553C915.129 458.86 1031.07 288.624 1036.5 34.4208L997.512 33.5868Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_3399_20261"
        x="0.996094"
        y="0.5"
        width="1035.51"
        height="771.844"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-10" dy="-10" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0.65658 0 0 0 0 0.804126 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3399_20261"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3399_20261"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const blueBar = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 6211 1036"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6233.13 1012.94L2647 1011.91L3286.36 110.805L6233.13 110.754V1012.94Z"
      fill="url(#paint0_linear_3394_15700)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6233.12 903.609L2737.39 902.1L3365.53 0.992737L6233.12 1.4259V903.609Z"
      fill="url(#paint1_linear_3394_15700)"
    />
    <g filter="url(#filter0_ddd_3394_15700)">
      <path
        d="M3429.18 82.5859H3571.83L3418.95 311.9H3276.3L3429.18 82.5859Z"
        fill="white"
      />
    </g>
    <path
      d="M3663.34 90.125H3805.99L3653.11 319.439H3510.46L3663.34 90.125Z"
      fill="#122931"
    />
    <path
      d="M3910.41 90.125H4053.06L3900.18 319.439H3757.54L3910.41 90.125Z"
      fill="#122931"
    />
    <defs>
      <filter
        id="filter0_ddd_3394_15700"
        x="3240.3"
        y="52.5859"
        width="361.523"
        height="289.312"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-32" dy="17" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3394_15700"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="15" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0.997 0 0 0 0 1 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_3394_15700"
          result="effect2_dropShadow_3394_15700"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="15" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 1 0 0 0 0 0.961 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_3394_15700"
          result="effect3_dropShadow_3394_15700"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_3394_15700"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_3394_15700"
        x1="4279.09"
        y1="35.5535"
        x2="4895.23"
        y2="922.767"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00AEC3" />
        <stop offset="1" stopColor="#017C8E" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3394_15700"
        x1="4193.09"
        y1="-247.704"
        x2="5126.39"
        y2="1243.14"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00C3DE" />
        <stop offset="1" stopColor="#006D8B" />
      </linearGradient>
    </defs>
  </svg>
);

export const redBar = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 6403 1035"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M-9.9989 111.008L2685.23 112.096L2179.03 1022.99H-9.9989V111.008Z"
      fill="url(#paint0_linear_3394_15711)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M-4.01434 0L2611.95 1.08829L2114.65 911.987H-4.01434V0Z"
      fill="url(#paint1_linear_3394_15711)"
    />
    <g filter="url(#filter0_ddd_3394_15711)">
      <path
        d="M2325.81 77.0625H2470.01L2343.22 308.868H2199.02L2325.81 77.0625Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter1_ddd_3394_15711)">
      <path
        d="M2098.36 77.0625H2242.55L2115.77 308.868H1971.57L2098.36 77.0625Z"
        fill="white"
      />
    </g>
    <path
      d="M1870.9 82.5078H2015.1L1888.32 314.314H1744.12L1870.9 82.5078Z"
      fill="#2F181A"
    />
    <defs>
      <filter
        id="filter0_ddd_3394_15711"
        x="2169.02"
        y="47.0625"
        width="330.984"
        height="291.805"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-24" dy="14" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3394_15711"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="15" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.0958334 0 0 0 0 0.334532 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_3394_15711"
          result="effect2_dropShadow_3394_15711"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="15" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.0958334 0 0 0 0 0.334532 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_3394_15711"
          result="effect3_dropShadow_3394_15711"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_3394_15711"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_ddd_3394_15711"
        x="1941.57"
        y="47.0625"
        width="330.984"
        height="291.805"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-24" dy="14" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3394_15711"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="15" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.0958334 0 0 0 0 0.334532 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_3394_15711"
          result="effect2_dropShadow_3394_15711"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="15" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.0958334 0 0 0 0 0.334532 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_3394_15711"
          result="effect3_dropShadow_3394_15711"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_3394_15711"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_3394_15711"
        x1="1777.49"
        y1="1022.99"
        x2="2326.19"
        y2="38.6805"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BB4538" />
        <stop offset="1" stopColor="#E97F81" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3394_15711"
        x1="1587.88"
        y1="982.18"
        x2="1917.4"
        y2="-116.816"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CC2837" />
        <stop offset="0.995359" stopColor="#F64E6A" />
      </linearGradient>
    </defs>
  </svg>
);

export const yellowBar = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1148 3978"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1071.42 151.492L0.00158691 688.492V0.992188V3517.44L535.712 3919.44L1071.42 3517.44L1071.42 151.492Z"
      fill="url(#paint0_linear_3399_20055)"
    />
    <path
      d="M1071.42 151.492L0.00158691 688.492V0.992188V3517.44L535.712 3919.44L1071.42 3517.44L1071.42 151.492Z"
      fill="black"
      fillOpacity="0.4"
    />
    <path
      d="M1148 221.992L76.5609 757.492L76.5615 61.8359L76.5585 3575.34L612.267 3977.34L1147.98 3575.34L1148 221.992Z"
      fill="url(#paint1_linear_3399_20055)"
    />
    <g filter="url(#filter0_ddd_3399_20055)">
      <path
        d="M751 948.992V790.207L1026 652.992V811.778L751 948.992Z"
        fill="white"
      />
      <path
        d="M751 1183.99V1025.21L1026 887.992V1046.78L751 1183.99Z"
        fill="white"
      />
      <path
        d="M751 713.992V555.207L1026 417.992V576.778L751 713.992Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_ddd_3399_20055"
        x="721"
        y="387.992"
        width="335"
        height="832"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-18" dy="32" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3399_20055"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="15" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.699001 0 0 0 0 0 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_3399_20055"
          result="effect2_dropShadow_3399_20055"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="15" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.693 0 0 0 0 0 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_3399_20055"
          result="effect3_dropShadow_3399_20055"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_3399_20055"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_3399_20055"
        x1="966.048"
        y1="377.256"
        x2="326.305"
        y2="3897.31"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFDBAB" />
        <stop offset="0.171875" stopColor="#FFD26C" />
        <stop offset="0.609375" stopColor="#FF9E00" />
        <stop offset="1" stopColor="#F0A543" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3399_20055"
        x1="1042.63"
        y1="350.481"
        x2="402.885"
        y2="3870.54"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD26C" />
        <stop offset="0.666667" stopColor="#FF9E00" />
        <stop offset="1" stopColor="#F0A543" />
      </linearGradient>
    </defs>
  </svg>
);

export const turquoiseBlur = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1699 1362"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.25"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1699 1362H0V0H1699V1362Z"
      fill="url(#paint0_radial_3594_45715)"
    />
    <defs>
      <radialGradient
        id="paint0_radial_3594_45715"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(793.5 729.5) rotate(88.3247) scale(359.154 685.536)"
      >
        <stop offset="0.211066" stopColor="#08FF77" stopOpacity="0.84" />
        <stop offset="1" stopColor="#00FFD6" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
);

export const greenBlur = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1703 1363"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.25"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1706.02 1362.75H-1.46094V0.566406H1706.02V1362.75Z"
      fill="url(#paint0_radial_3594_45714)"
    />
    <defs>
      <radialGradient
        id="paint0_radial_3594_45714"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(437.167 729.013) rotate(92.9305) scale(393.197 730.375)"
      >
        <stop stopColor="#08FF00" stopOpacity="0.57" />
        <stop offset="1" stopColor="#00FF9D" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
);

export const blueBlur = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1700 1324"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1700 1324H-1V0H1700V1324Z"
      fill="url(#paint0_radial_3594_45719)"
    />
    <defs>
      <radialGradient
        id="paint0_radial_3594_45719"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(703 588) rotate(82.1858) scale(525.883 854.63)"
      >
        <stop stopColor="#00FFF4" stopOpacity="0.57" />
        <stop offset="1" stopColor="#0200A4" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
);

export const orangeBlur = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1696 1363"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.5"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1695.01 1362.19H0.8125V0H1695.01V1362.19Z"
      fill="url(#paint0_radial_3594_45696)"
    />
    <defs>
      <radialGradient
        id="paint0_radial_3594_45696"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(1159 664) rotate(91.9073) scale(510.783 948.794)"
      >
        <stop stopColor="#FF9F44" stopOpacity="0.57" />
        <stop offset="0.886788" stopColor="#FF2E00" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
);

export const blueBlur2 = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1701 1543"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.25"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1702.64 1543H0V0H1718L1702.64 1543Z"
      fill="url(#paint0_radial_3594_46620)"
      fillOpacity="0.75"
    />
    <defs>
      <radialGradient
        id="paint0_radial_3594_46620"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(1390.9 670.837) rotate(86.666) scale(515.385 928.393)"
      >
        <stop stopColor="#00FFAF" stopOpacity="0.57" />
        <stop offset="1" stopColor="#00FFEB" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
);

export const whiteBar = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 6397 1931"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 1049.7L5325.09 641.031L6414 557.464V1438.73L0 1930.96V1049.7Z"
      fill="white"
    />
    <path
      d="M5119 177.964L6158.15 350.193L6414 310.582V0L5119 177.964Z"
      fill="#E2E2E2"
    />
    <path
      d="M5119 177.964L5140.5 584.964L5325.09 641.031L6414 557.464V392.599L6158.15 350.193L5119 177.964Z"
      fill="#9E9E9E"
    />
  </svg>
);

export const whiteBarMobile = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 708 294"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.41786e-07 159.823L587.802 97.6015L708 84.8779L708 219.056L4.44777e-07 294.001L2.41786e-07 159.823Z"
      fill="white"
    />
    <path
      d="M565.053 27.0969L679.758 53.3198L708 47.2889L708 0.000975491L565.053 27.0969Z"
      fill="#E2E2E2"
    />
    <path
      d="M565.053 27.0969L567.427 89.065L587.802 97.6015L708 84.8779L708 59.7763L679.758 53.3198L565.053 27.0969Z"
      fill="#9E9E9E"
    />
  </svg>
);

export const yellowBarMobileGlow = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 5443 4163"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5443 4162.5H0V0H5443V4162.5Z"
      fill="url(#paint0_radial_52_3499)"
      fillOpacity="0.75"
    />
    <path
      d="M2113.5 1545.58L2717.5 2617H5442.84V1545.58L2113.5 1545.58Z"
      fill="url(#paint1_linear_52_3499)"
    />
    <path
      d="M2113.5 1545.58L2717.5 2617H5442.84V1545.58L2113.5 1545.58Z"
      fill="black"
      fillOpacity="0.4"
    />
    <path
      d="M2068 1469.02L2650.5 2497H5442.84V1469.02L2068 1469.02Z"
      fill="url(#paint2_linear_52_3499)"
    />
    <g filter="url(#filter0_ddd_52_3499)">
      <path d="M2881 1840H2701.29L2546 1565H2725.71L2881 1840Z" fill="white" />
      <path d="M3152 1840H2972.83L2818 1565H2997.17L3152 1840Z" fill="white" />
      <path d="M2609 1840H2429.29L2274 1565H2453.71L2609 1840Z" fill="white" />
    </g>
    <defs>
      <filter
        id="filter0_ddd_52_3499"
        x="2244"
        y="1535"
        width="938"
        height="335"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-12" dy="22" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_52_3499"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="15" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.658824 0 0 0 0 0 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_52_3499"
          result="effect2_dropShadow_52_3499"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="15" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.66 0 0 0 0 0 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_52_3499"
          result="effect3_dropShadow_52_3499"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_52_3499"
          result="shape"
        />
      </filter>
      <radialGradient
        id="paint0_radial_52_3499"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(3454.5 2032.5) rotate(90) scale(1573 2024.74)"
      >
        <stop stopColor="#FFC500" stopOpacity="0.57" />
        <stop offset="1" stopColor="#A44F00" stopOpacity="0" />
      </radialGradient>
      <linearGradient
        id="paint1_linear_52_3499"
        x1="2352.76"
        y1="1650.95"
        x2="5872.82"
        y2="2290.7"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFDBAB" />
        <stop offset="0.171875" stopColor="#FFD26C" />
        <stop offset="0.609375" stopColor="#FF9E00" />
        <stop offset="1" stopColor="#F0A543" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_52_3499"
        x1="2217.98"
        y1="1574.37"
        x2="5738.04"
        y2="2214.11"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD26C" />
        <stop offset="0.666667" stopColor="#FF9E00" />
        <stop offset="1" stopColor="#F0A543" />
      </linearGradient>
    </defs>
  </svg>
);

export const redBarMobileGlow = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 5444 5068"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5444 5068L0 5068V0H5444V5068Z"
      fill="url(#paint0_radial_52_3497)"
    />
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.000732422 2069.57H3044L2424.5 3093H0.000732422V2069.57Z"
      fill="url(#paint1_linear_52_3497)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 1945H2980L2356 2968.43H0V1945Z"
      fill="url(#paint2_linear_52_3497)"
    />
    <g filter="url(#filter0_ddd_52_3497)">
      <path
        d="M2638.72 2041.7H2812.9L2638.23 2321.7H2464.05L2638.72 2041.7Z"
        fill="white"
      />
      <path
        d="M2363.98 2041.7H2538.16L2363.49 2321.7H2189.31L2363.98 2041.7Z"
        fill="white"
      />
    </g>
    <path
      d="M2091.67 2048.81H2265.85L2091.18 2328.81H1917L2091.67 2048.81Z"
      fill="#2F181A"
    />
    <defs>
      <filter
        id="filter0_ddd_52_3497"
        x="2151.31"
        y="2011.7"
        width="691.594"
        height="340"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-34" dy="16" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_52_3497"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="15" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.384314 0 0 0 0 0.679843 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_52_3497"
          result="effect2_dropShadow_52_3497"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="15" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.384314 0 0 0 0 0.678431 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_52_3497"
          result="effect3_dropShadow_52_3497"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_52_3497"
          result="shape"
        />
      </filter>
      <radialGradient
        id="paint0_radial_52_3497"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(2233.19 2592.91) rotate(92.9104) scale(1462.86 2698.7)"
      >
        <stop stopColor="#FF0073" stopOpacity="0.57" />
        <stop offset="1" stopColor="#A44500" stopOpacity="0" />
      </radialGradient>
      <linearGradient
        id="paint1_linear_52_3497"
        x1="1998.92"
        y1="3093"
        x2="2614.67"
        y2="1988.4"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BB4538" />
        <stop offset="1" stopColor="#E97F81" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_52_3497"
        x1="1786.14"
        y1="3047.2"
        x2="2155.92"
        y2="1813.91"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CC2837" />
        <stop offset="0.995359" stopColor="#F64E6A" />
      </linearGradient>
    </defs>
  </svg>
);

export const blueBarMobileGlow = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 5444 4013"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.35"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5444 4013H0V0.5H5444V4013Z"
      fill="url(#paint0_radial_52_3495)"
    />
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5444 2089.01L1393 2089.01L2107.29 1065.58H5444V2089.01Z"
      fill="url(#paint1_linear_52_3495)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5444 1963.21L1482 1963.21L2185.59 941L5444 941V1963.21Z"
      fill="url(#paint2_linear_52_3495)"
    />
    <g filter="url(#filter0_ddd_52_3495)">
      <path
        d="M2253.02 1030H2425.66L2240.64 1300.8H2068L2253.02 1030Z"
        fill="white"
      />
    </g>
    <path
      d="M2487.02 1038H2659.66L2474.64 1308.8H2302L2487.02 1038Z"
      fill="#122931"
    />
    <path
      d="M2726.02 1038H2898.66L2713.64 1308.8H2541L2726.02 1038Z"
      fill="#122931"
    />
    <defs>
      <filter
        id="filter0_ddd_52_3495"
        x="2030"
        y="1000"
        width="425.658"
        height="330.799"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-34" dy="16" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_52_3495"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="15" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0.997 0 0 0 0 1 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_52_3495"
          result="effect2_dropShadow_52_3495"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="15" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 1 0 0 0 0 0.961 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_52_3495"
          result="effect3_dropShadow_52_3495"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_52_3495"
          result="shape"
        />
      </filter>
      <radialGradient
        id="paint0_radial_52_3495"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(3564.17 1512.02) rotate(92.9593) scale(1478.22 2772.69)"
      >
        <stop stopColor="#00C0FF" stopOpacity="0.57" />
        <stop offset="1" stopColor="#00FFF0" stopOpacity="0" />
      </radialGradient>
      <linearGradient
        id="paint1_linear_52_3495"
        x1="3454.4"
        y1="980.109"
        x2="4153.35"
        y2="1986.56"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00AEC3" />
        <stop offset="1" stopColor="#017C8E" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_52_3495"
        x1="3130.87"
        y1="658.892"
        x2="4189.6"
        y2="2350.09"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00C3DE" />
        <stop offset="1" stopColor="#006D8B" />
      </linearGradient>
    </defs>
  </svg>
);

export const blueTopGlow = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1728 870"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="1728" height="870" fill="url(#paint0_linear_356_1545)" />
    <defs>
      <linearGradient
        id="paint0_linear_356_1545"
        x1="864"
        y1="0"
        x2="864"
        y2="870"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#02CEFF" stopOpacity="0.22" />
        <stop offset="1" stopColor="#151515" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export const blueSubscriptionBar = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1693 342"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1310.5 341.598L0 341.599L382.287 37.1178L1692.79 37.1175L1310.5 341.598Z"
      fill="url(#paint0_linear_356_1525)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1288.5 304.488L46.9102 304.482L422.485 0.000151468L1664.07 0.0063325L1288.5 304.488Z"
      fill="url(#paint1_linear_356_1525)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_356_1525"
        x1="1087.84"
        y1="11.6587"
        x2="1238.96"
        y2="396.719"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00AEC3" />
        <stop offset="1" stopColor="#017C8E" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_356_1525"
        x1="917.298"
        y1="-84.0204"
        x2="1137.77"
        y2="539.156"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00C3DE" />
        <stop offset="1" stopColor="#006D8B" />
      </linearGradient>
    </defs>
  </svg>
);

export const blueSubscriptionBarMobile = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 768 1591"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="768" height="1591" fill="#151515" />
    <rect
      width="768"
      height="1591"
      fill="url(#paint0_linear_12_188)"
      fillOpacity="0.4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M768.001 300L0.00127411 299.757L0 299.757L0.00127411 225.257L166.043 74.4534H768.001V300Z"
      fill="url(#paint1_linear_12_188)"
      fillOpacity="0.4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M768.001 272.547L0.00127411 272.294V224.609L192.124 47L768.001 47V272.547Z"
      fill="url(#paint2_linear_12_188)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_12_188"
        x1="384"
        y1="0"
        x2="384"
        y2="1591"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00CFFF" />
        <stop offset="1" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_12_188"
        x1="390.222"
        y1="321.129"
        x2="573.764"
        y2="118.991"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00AEC3" />
        <stop offset="1" stopColor="#017C8E" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_12_188"
        x1="513.176"
        y1="-15.1733"
        x2="693.168"
        y2="430.994"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00C3DE" />
        <stop offset="1" stopColor="#006D8B" />
      </linearGradient>
    </defs>
  </svg>
);

export const redIncludedTierArrow = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 27 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.5 7.77817C25.8807 7.77817 27 8.89746 27 10.2782C27 11.6589 25.8807 12.7782 24.5 12.7782H8.5379L12.0842 16.3245C13.0605 17.3008 13.0605 18.8837 12.0842 19.86C11.1079 20.8363 9.52495 20.8363 8.54864 19.86L0.767767 12.0808C0.30292 11.6268 0 10.9793 0 10.2782C0 9.58262 0.297715 8.94 0.756162 8.4868L8.54594 0.732233C9.52225 -0.244078 11.1052 -0.244078 12.0815 0.732233C13.0578 1.70854 13.0578 3.29146 12.0815 4.26777L8.57107 7.77817H24.5Z"
      fill="url(#paint0_linear_164_9)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_164_9"
        x1="13.5"
        y1="0"
        x2="13.5"
        y2="20.5922"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FD6A74" />
        <stop offset="1" stopColor="#EE3C4C" />
      </linearGradient>
    </defs>
  </svg>
);

export const orangeIncludedTierArrow = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 27 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.5 7.77817C25.8807 7.77817 27 8.89746 27 10.2782C27 11.6589 25.8807 12.7782 24.5 12.7782H8.5379L12.0842 16.3245C13.0605 17.3008 13.0605 18.8837 12.0842 19.86C11.1079 20.8363 9.52495 20.8363 8.54864 19.86L0.767767 12.0808C0.30292 11.6268 0 10.9793 0 10.2782C0 9.58262 0.297715 8.94 0.756162 8.4868L8.54594 0.732233C9.52225 -0.244078 11.1052 -0.244078 12.0815 0.732233C13.0578 1.70854 13.0578 3.29146 12.0815 4.26777L8.57107 7.77817H24.5Z"
      fill="url(#paint0_linear_164_10)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_164_10"
        x1="13.5"
        y1="0"
        x2="13.5"
        y2="20.5922"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF8F35" />
        <stop offset="1" stopColor="#FF6841" />
      </linearGradient>
    </defs>
  </svg>
);

export const greenDiscountBar = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 109 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1.16419"
      y="14.347"
      width="106.5"
      height="4.85802"
      transform="rotate(-7 1.16419 14.347)"
      fill="#C3E7E3"
      stroke="url(#paint0_linear_3667_149)"
      strokeWidth="1.5"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3667_149"
        x1="2"
        y1="15"
        x2="105.841"
        y2="18.823"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#12A394" />
        <stop offset="1" stopColor="#0B9587" />
      </linearGradient>
    </defs>
  </svg>
);

export const redDiscountBar = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 109 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1.16419"
      y="14.347"
      width="106.5"
      height="4.85802"
      transform="rotate(-7 1.16419 14.347)"
      fill="#FCD2D5"
      stroke="url(#paint0_linear_103_386)"
      strokeWidth="1.5"
    />
    <defs>
      <linearGradient
        id="paint0_linear_103_386"
        x1="2"
        y1="15"
        x2="105.841"
        y2="18.823"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F34F5C" />
        <stop offset="1" stopColor="#EE3F4E" />
      </linearGradient>
    </defs>
  </svg>
);

export const orangeDiscountBar = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 109 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1.16419"
      y="14.347"
      width="106.5"
      height="4.85802"
      transform="rotate(-7 1.16419 14.347)"
      fill="#FFDACF"
      stroke="url(#paint0_linear_103_458)"
      strokeWidth="1.5"
    />
    <defs>
      <linearGradient
        id="paint0_linear_103_458"
        x1="3.82252"
        y1="16.561"
        x2="104.493"
        y2="16.8371"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF713C" />
        <stop offset="1" stopColor="#FF5643" />
      </linearGradient>
    </defs>
  </svg>
);

export const mostPopularBanner = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 195 195"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M190.643 186.125L190.643 194.931C190.643 194.931 194.036 195.38 194.03 192.431C194.025 189.482 190.643 186.125 190.643 186.125Z"
      fill="url(#paint0_linear_176_181)"
    />
    <path
      d="M8.14834 3.3869L0.0244643 3.38702C0.0244643 3.38702 -0.424528 -0.00521786 2.52448 0.000129134C5.47349 0.00547613 8.14834 3.3869 8.14834 3.3869Z"
      fill="url(#paint1_linear_176_181)"
    />
    <path
      d="M8.14834 3.3869L99.3959 94.7561L190.643 186.125C190.643 186.125 194.025 189.482 194.03 192.431C194.03 189.292 194.029 119.746 194.03 117.238C194.031 114.731 190.643 111.585 190.643 111.585L82.1955 3.3869C82.1955 3.3869 79.0414 -0.00114104 76.534 2.88294e-07C74.0265 0.00114162 5.6637 0.000244017 2.52448 0.000129134C5.47349 0.00547613 8.14834 3.3869 8.14834 3.3869Z"
      fill="url(#paint2_linear_176_181)"
    />
    <path
      d="M8.14834 3.3869L99.3959 94.7561L190.643 186.125C190.643 186.125 194.025 189.482 194.03 192.431C194.03 189.292 194.029 119.746 194.03 117.238C194.031 114.731 190.643 111.585 190.643 111.585L82.1955 3.3869C82.1955 3.3869 79.0414 -0.00114104 76.534 2.88294e-07C74.0265 0.00114162 5.6637 0.000244017 2.52448 0.000129134C5.47349 0.00547613 8.14834 3.3869 8.14834 3.3869Z"
      fill="url(#paint3_linear_176_181)"
      fillOpacity="0.5"
    />
    <path
      d="M8.14834 3.3869L99.3959 94.7561L190.643 186.125C190.643 186.125 194.025 189.482 194.03 192.431C194.03 189.292 194.029 119.746 194.03 117.238C194.031 114.731 190.643 111.585 190.643 111.585L82.1955 3.3869C82.1955 3.3869 79.0414 -0.00114104 76.534 2.88294e-07C74.0265 0.00114162 5.6637 0.000244017 2.52448 0.000129134C5.47349 0.00547613 8.14834 3.3869 8.14834 3.3869Z"
      fill="url(#paint4_linear_176_181)"
      fillOpacity="0.8"
    />
    <path
      d="M190.643 194.931L190.643 186.125L99.3959 94.7561L8.14834 3.3869L0.0244643 3.38702L3.63495 3.38697L190.643 190.442L190.643 194.931Z"
      fill="url(#paint5_linear_176_181)"
      fillOpacity="0.2"
    />
    <defs>
      <linearGradient
        id="paint0_linear_176_181"
        x1="185.958"
        y1="156.306"
        x2="200.755"
        y2="159.55"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#232323" />
        <stop offset="1" stopColor="#B3562A" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_176_181"
        x1="41"
        y1="1.4766e-06"
        x2="35.3887"
        y2="14.1004"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#232323" />
        <stop offset="1" stopColor="#D36835" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_176_181"
        x1="44.5"
        y1="4.49996"
        x2="176.861"
        y2="149.516"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF8F34" />
        <stop offset="0.515625" stopColor="#FFBF2C" />
        <stop offset="1" stopColor="#FF7A3A" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_176_181"
        x1="178"
        y1="147.5"
        x2="204"
        y2="147.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FD9238" stopOpacity="0" />
        <stop offset="0.512603" stopColor="#FFBB3F" />
        <stop offset="1" stopColor="#FF8E39" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_176_181"
        x1="32"
        y1="17"
        x2="31"
        y2="-10"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FD9238" stopOpacity="0" />
        <stop offset="0.512603" stopColor="#FFBB3F" />
        <stop offset="0.78641" stopColor="#FF8E39" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_176_181"
        x1="194"
        y1="189.5"
        x2="4.83906"
        y2="3.6728"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity="0" />
        <stop offset="0.09375" />
        <stop offset="0.895833" />
        <stop offset="1" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export const mostPopularBannerMobile = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 235 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M230.391 2.4C230.391 2.4 234.591 2.4 234.591 1.8C234.591 0.6 230.391 0 230.391 0V2.4Z"
      fill="url(#paint0_linear_330_8)"
    />
    <path
      d="M230.391 2.4L28.7333 2.59291L0 31.2025L28.7335 59.9999L230.391 60C232.412 60 234.602 58.8 234.602 54C234.602 49.2 234.591 24.2942 234.591 1.8C234.591 2.4 230.391 2.4 230.391 2.4Z"
      fill="url(#paint1_linear_330_8)"
    />
    <path
      d="M230.391 2.4L28.7333 2.59291L0 31.2025L28.7335 59.9999L230.391 60C232.412 60 234.602 58.8 234.602 54C234.602 49.2 234.591 24.2942 234.591 1.8C234.591 2.4 230.391 2.4 230.391 2.4Z"
      fill="url(#paint2_linear_330_8)"
      fillOpacity="0.5"
    />
    <defs>
      <linearGradient
        id="paint0_linear_330_8"
        x1="129"
        y1="2.5"
        x2="145.5"
        y2="8"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B17D20" />
        <stop offset="1" stopColor="#533500" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_330_8"
        x1="145.5"
        y1="60"
        x2="111.5"
        y2="2.1688e-06"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFA437" />
        <stop offset="0.489583" stopColor="#FFB635" />
        <stop offset="1" stopColor="#FF9938" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_330_8"
        x1="225.5"
        y1="26"
        x2="236"
        y2="26"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="0.730167" stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.74" />
      </linearGradient>
    </defs>
  </svg>
);

export const subscriptionInfoIcon = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.6516 6.24961C13.6516 7.16088 12.9128 7.89961 12.0016 7.89961C11.0903 7.89961 10.3516 7.16088 10.3516 6.24961C10.3516 5.33834 11.0903 4.59961 12.0016 4.59961C12.9128 4.59961 13.6516 5.33834 13.6516 6.24961Z"
      fill="#B2B2B2"
    />
    <path
      d="M10.75 9.5C10.75 8.94772 11.1977 8.5 11.75 8.5H12.25C12.8023 8.5 13.25 8.94772 13.25 9.5V18.75C13.25 19.3023 12.8023 19.75 12.25 19.75H11.75C11.1977 19.75 10.75 19.3023 10.75 18.75V9.5Z"
      fill="#B2B2B2"
    />
    <path
      d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM1.99311 12C1.99311 17.5267 6.47335 22.0069 12 22.0069C17.5267 22.0069 22.0069 17.5267 22.0069 12C22.0069 6.47335 17.5267 1.99311 12 1.99311C6.47335 1.99311 1.99311 6.47335 1.99311 12Z"
      fill="#B2B2B2"
    />
  </svg>
);

export const desktopRequiredCircleIcon = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M90 50C90 72.0914 72.0914 90 50 90C27.9086 90 10 72.0914 10 50C10 27.9086 27.9086 10 50 10C72.0914 10 90 27.9086 90 50ZM25.0163 50C25.0163 63.7981 36.2019 74.9837 50 74.9837C63.7981 74.9837 74.9837 63.7981 74.9837 50C74.9837 36.2019 63.7981 25.0163 50 25.0163C36.2019 25.0163 25.0163 36.2019 25.0163 50Z"
      fill="white"
    />
  </svg>
);

export const curvedButton = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 272 125"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_i_858_10119)">
      <path
        d="M0 0H272V125H125C55.9644 125 0 69.0356 0 0Z"
        fill="url(#paint0_linear_858_10119)"
      />
      <path
        d="M0 0H272V125H125C55.9644 125 0 69.0356 0 0Z"
        fill="url(#paint1_linear_858_10119)"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_858_10119"
        x="0"
        y="-1.44"
        width="272"
        height="126.44"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-4.32" />
        <feGaussianBlur stdDeviation="0.72" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0916667 0 0 0 0 0.0916667 0 0 0 0 0.0916667 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_858_10119"
        />
      </filter>
      <linearGradient
        id="paint0_linear_858_10119"
        x1="272"
        y1="5.625"
        x2="170.295"
        y2="209.492"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#222222" stopOpacity="0.98" />
        <stop offset="1" stopColor="#444444" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_858_10119"
        x1="16.4979"
        y1="145.146"
        x2="306.014"
        y2="42.261"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#505050" stopOpacity="0.67" />
        <stop offset="1" stopColor="#353535" />
      </linearGradient>
    </defs>
  </svg>
);

export const grayPlusButton = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 77 75"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 10.6499V64.3501C0 70.2319 4.76813 75 10.6499 75H66.3501C72.2319 75 77 70.2319 77 64.3501V10.6499C77 4.76813 72.2319 0 66.3501 0H10.6499C4.76813 0 0 4.76813 0 10.6499Z"
      fill="currentColor"
    />
    <rect
      x="13"
      y="41.5703"
      width="7.14286"
      height="50"
      rx="3.57143"
      transform="rotate(-90 13 41.5703)"
      fill="#D9D9D9"
    />
    <rect
      x="34.4277"
      y="13"
      width="7.14286"
      height="50"
      rx="3.57143"
      fill="#D9D9D9"
    />
  </svg>
);

export const grayCrossButton = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 63 63"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M61 31C61 14.4315 47.5685 1 31 1C14.4315 1 1 14.4315 1 31C1 47.5685 14.4315 61 31 61C47.5685 61 61 47.5685 61 31Z"
      fill="#FFF"
      fillOpacity="0.75"
    />
    <rect
      x="17.5684"
      y="48.9453"
      width="4.43668"
      height="44.3668"
      rx="2.21834"
      transform="rotate(-135 17.5684 48.9453)"
      fill="#232323"
    />
    <rect
      x="14.4316"
      y="16.9453"
      width="4.43668"
      height="44.3668"
      rx="2.21834"
      transform="rotate(-45 14.4316 16.9453)"
      fill="#232323"
    />
  </svg>
);

export const star = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.67442 0.358704L6.90806 4.10728L10.9002 4.10728L7.6705 6.42403L8.90414 10.1726L5.67442 7.85586L2.4447 10.1726L3.67834 6.42403L0.448619 4.10728L4.44077 4.10728L5.67442 0.358704Z"
      fill="white"
    />
  </svg>
);

export const AIButtonThreads = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 659 313"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M172.405 134.662H144.004V163.083L122.704 183.609H31.9787M31.9787 176.504H117.181L133.748 159.925V129.136L137.693 125.189H172.405M172.405 116.505H133.748L128.226 122.031V157.557L117.181 168.609H42.2346M42.2346 163.083H107.714L121.915 148.873V112.557L129.015 105.452H172.405M172.405 95.9785H127.437L114.815 108.61V143.347L105.348 152.82H2M2 145.715H102.192L107.714 140.189V47.8209L117.181 38.3473H172.405M172.405 88.0838H117.181M117.181 79.3996H172.405M172.405 69.926H117.181M117.181 62.8208H172.405M133.748 53.3472H172.405M140.06 28.8737H172.405"
      stroke="url(#paint0_linear_1334_1624)"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      d="M259.939 150.56V166.866L171 255.732M270.547 150.56V166.866L176.712 260.624M184.871 268.777L279.522 174.203V150.56M290.13 150.56V174.203L190.583 273.669M229.749 273.669V260.624L299.105 191.325V150.56M309.713 150.56V164.42M319.504 150.56V311.172M358.674 281.006L348.066 270.407V150.56M356.543 150.56V220.675M365.519 150.56V208.446L377.758 220.675V301.388M388.365 301.388V220.675L372.046 204.369V150.56M380.206 150.56V201.923L401.421 223.121V301.388M433.243 301.388V231.274L389.997 188.063V150.56M399.789 151.375V179.91L455.274 235.35V301.388M465.065 301.388V235.35L407.132 177.465V150.56M415.292 150.56V175.834L478.121 238.611V301.388"
      stroke="url(#paint1_linear_1334_1624)"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      d="M476 153.737H495.023L536.591 195.294H650.024L656.365 201.633M656.365 183.32L650.729 177.685H533.773L502.068 145.989H476M476 137.537H509.114L528.841 157.259H652.138L657.774 162.894M657.774 144.58L652.138 138.946H527.432L517.568 129.085H476M467.022 38.9166H500.136L537.477 1.58575H643.159L648.796 7.22058M516.34 12.7164L500.136 28.9166H454.34M454.34 21.1687H482.522"
      stroke="url(#paint2_linear_1334_1624)"
      strokeWidth="3"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1334_1624"
        x1="-24"
        y1="100.918"
        x2="187"
        y2="78.918"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.234375" stopColor="#FF7900" stopOpacity="0" />
        <stop offset="0.59375" stopColor="#BE7200" stopOpacity="0.432292" />
        <stop offset="1" stopColor="#FFB800" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1334_1624"
        x1="310.85"
        y1="311.172"
        x2="310.85"
        y2="150.56"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.234375" stopColor="#FF7900" stopOpacity="0" />
        <stop offset="0.59375" stopColor="#BE7200" stopOpacity="0.432292" />
        <stop offset="1" stopColor="#FFB800" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1334_1624"
        x1="614.773"
        y1="185.918"
        x2="441.773"
        y2="79.9181"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.234375" stopColor="#FF7900" stopOpacity="0" />
        <stop offset="0.59375" stopColor="#BE7200" stopOpacity="0.432292" />
        <stop offset="1" stopColor="#FFB800" />
      </linearGradient>
    </defs>
  </svg>
);

export const AIIcon = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 104 104"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="51.8287"
      cy="51.8281"
      r="39"
      transform="rotate(25 51.8287 51.8281)"
      fill="#292929"
    />
    <g filter="url(#filter0_f_1185_1116)">
      <ellipse
        cx="45.8017"
        cy="45.7988"
        rx="45.8017"
        ry="45.7988"
        transform="matrix(0.996195 -0.0871502 0.0871614 0.996194 1.86719 9.73438)"
        fill="url(#paint0_radial_1185_1116)"
        fillOpacity="0.5"
      />
    </g>
    <g filter="url(#filter1_f_1185_1116)">
      <ellipse
        cx="51.5961"
        cy="51.7628"
        rx="18.8344"
        ry="18.8332"
        fill="url(#paint1_radial_1185_1116)"
      />
    </g>
    <path
      d="M85.8222 51.7786C85.8222 70.4769 70.6632 85.6355 51.9629 85.6355C33.2626 85.6355 18.1036 70.4769 18.1036 51.7786C18.1036 33.0803 33.2626 17.9218 51.9629 17.9218C70.6632 17.9218 85.8222 33.0803 85.8222 51.7786Z"
      stroke="url(#paint2_radial_1185_1116)"
      strokeOpacity="0.75"
      strokeWidth="13"
    />
    <g filter="url(#filter2_f_1185_1116)">
      <ellipse
        cx="3.61343"
        cy="3.61323"
        rx="3.61343"
        ry="3.61323"
        transform="matrix(0.96593 -0.258804 0.258835 0.965922 82.541 32.8438)"
        fill="url(#paint3_radial_1185_1116)"
      />
    </g>
    <ellipse
      cx="51.962"
      cy="51.7686"
      rx="30.5753"
      ry="30.5733"
      stroke="url(#paint4_radial_1185_1116)"
      strokeOpacity="0.75"
      strokeWidth="11"
    />
    <g filter="url(#filter3_f_1185_1116)">
      <ellipse
        cx="2.4769"
        cy="2.47676"
        rx="2.4769"
        ry="2.47676"
        transform="matrix(0.96593 -0.258804 0.258835 0.965922 75.8672 60.2656)"
        fill="url(#paint5_radial_1185_1116)"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_1185_1116"
        x="4.28164"
        y="4.1625"
        width="94.4094"
        height="94.4094"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.7"
          result="effect1_foregroundBlur_1185_1116"
        />
      </filter>
      <filter
        id="filter1_f_1185_1116"
        x="31.3617"
        y="31.5297"
        width="40.468"
        height="40.4641"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.7"
          result="effect1_foregroundBlur_1185_1116"
        />
      </filter>
      <filter
        id="filter2_f_1185_1116"
        x="82.3516"
        y="30.7812"
        width="9.22852"
        height="9.23438"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.5"
          result="effect1_foregroundBlur_1185_1116"
        />
      </filter>
      <filter
        id="filter3_f_1185_1116"
        x="75.9238"
        y="59.0391"
        width="5.95508"
        height="5.95312"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.25"
          result="effect1_foregroundBlur_1185_1116"
        />
      </filter>
      <radialGradient
        id="paint0_radial_1185_1116"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(45.8017 45.7988) rotate(90) scale(45.7988 45.8017)"
      >
        <stop stopColor="#FFCB00" />
        <stop offset="0.438517" stopColor="#FF8B00" />
        <stop offset="0.489583" stopColor="#FF8D00" />
        <stop offset="0.536458" stopColor="#FF7D00" />
        <stop offset="1" stopColor="#FF4600" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_1185_1116"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(51.5961 51.7629) rotate(90) scale(18.8332 18.8344)"
      >
        <stop stopColor="#FFE61F" />
        <stop offset="0.666667" stopColor="#FF9812" />
        <stop offset="1" stopColor="#FF7100" stopOpacity="0.31" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_1185_1116"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(51.9629 51.7786) rotate(90) scale(40.3568 40.3594)"
      >
        <stop
          offset="0.922664"
          stopColor="var(--color-brand-meta-orange)"
          stopOpacity="0"
        />
        <stop offset="0.94016" stopColor="#FFA725" />
        <stop offset="0.957501" stopColor="#FFD515" />
        <stop offset="0.975569" stopColor="#FFA200" />
        <stop
          offset="0.98901"
          stopColor="var(--color-brand-meta-orange)"
          stopOpacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint3_radial_1185_1116"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(3.61343 3.61323) rotate(90) scale(3.61323 3.61343)"
      >
        <stop stopColor="var(--color-brand-meta-orange)" />
        <stop offset="0.5625" stopColor="#FF8100" />
        <stop offset="1" stopColor="#FFB23E" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_1185_1116"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(51.962 51.7686) rotate(90) scale(30.5733 30.5753)"
      >
        <stop
          offset="0.894874"
          stopColor="var(--color-brand-meta-orange)"
          stopOpacity="0"
        />
        <stop offset="0.944314" stopColor="#FFB955" />
        <stop
          offset="1"
          stopColor="var(--color-brand-meta-orange)"
          stopOpacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint5_radial_1185_1116"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(2.4769 2.47676) rotate(90) scale(2.47676 2.4769)"
      >
        <stop stopColor="var(--color-brand-meta-orange)" />
        <stop offset="0.5625" stopColor="#FF8100" />
        <stop offset="1" stopColor="#FFB23E" />
      </radialGradient>
    </defs>
  </svg>
);

export const emptyPlayerSlot = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 212 343"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M105.892 1.71357C106.08 1.96543 106.297 2.2516 106.541 2.56496C107.468 3.75622 108.79 5.34839 110.365 6.94448C111.936 8.53704 113.781 10.1565 115.758 11.3833C117.726 12.6047 119.899 13.4843 122.108 13.4843C126.115 13.4843 128.72 11.2858 130.279 9.17746C131.057 8.12528 131.589 7.07897 131.927 6.29809C132.01 6.10671 132.081 5.93038 132.142 5.77277C149.742 8.01325 158.989 14.2711 172.934 25.4371C173.507 25.8961 174.079 26.3544 174.649 26.8112C181.034 31.9315 187.197 36.8733 193.094 40.6968C199.171 44.6372 205.082 47.4711 210.785 48.0513L210.785 284.636C210.785 287.714 210.159 297.674 199.899 301.489C193.619 303.823 185.937 306.333 177.623 309.05L176.574 309.393C167.867 312.238 158.521 315.305 149.453 318.617C140.386 321.928 131.574 325.492 123.933 329.335C116.706 332.969 110.47 336.882 106.053 341.109C101.705 336.844 95.494 332.9 88.2676 329.239C80.6241 325.366 71.7782 321.777 62.6626 318.444C53.5453 315.109 44.1369 312.023 35.3689 309.161L34.1717 308.77C25.8536 306.055 18.1678 303.546 11.8859 301.213C1.62539 297.402 1 287.451 1 284.376L1.00008 48.0091C6.70261 47.4294 12.614 44.5981 18.6907 40.6613C24.5872 36.8412 30.7504 31.9039 37.1361 26.7882C37.7058 26.3317 38.2773 25.8739 38.8506 25.4153C52.7957 14.2592 62.0424 8.00692 79.6429 5.76846C79.7038 5.92588 79.7754 6.10198 79.8582 6.2931C80.1963 7.07336 80.7287 8.11881 81.5067 9.17011C83.0656 11.2768 85.6704 13.4731 89.6775 13.4731C91.8854 13.4731 94.0591 12.5944 96.0269 11.374C98.0033 10.1483 99.8486 8.53036 101.42 6.93921C102.995 5.34452 104.317 3.75376 105.244 2.56355C105.488 2.25075 105.705 1.96505 105.892 1.71357Z"
      fill="url(#paint0_linear_1249_1565)"
      stroke="url(#paint1_linear_1249_1565)"
      strokeWidth="2"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1249_1565"
        x1="106"
        y1="13"
        x2="139"
        y2="316"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#232323" />
        <stop offset="0.368553" stopColor="#2C2C2C" />
        <stop offset="0.968983" stopColor="#060606" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1249_1565"
        x1="51.1642"
        y1="-5"
        x2="216.272"
        y2="279.751"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#333333" />
        <stop offset="1" stopColor="#2E2E2E" />
      </linearGradient>
    </defs>
  </svg>
);

export const emptyPlayerSlotHovered = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 212 344"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M105.892 2.47138C106.08 2.72325 106.297 3.00942 106.541 3.32277C107.468 4.51403 108.79 6.1062 110.365 7.70229C111.936 9.29486 113.781 10.9143 115.758 12.1411C117.726 13.3625 119.899 14.2421 122.108 14.2421C126.115 14.2421 128.72 12.0436 130.279 9.93527C131.057 8.88309 131.589 7.83679 131.927 7.0559C132.01 6.86452 132.081 6.6882 132.142 6.53059C149.742 8.77106 158.989 15.0289 172.934 26.1949C173.507 26.6539 174.079 27.1122 174.649 27.5691C181.034 32.6893 187.197 37.6311 193.094 41.4546C199.171 45.395 205.082 48.2289 210.785 48.8091L210.785 285.394C210.785 288.472 210.159 298.432 199.899 302.246C193.619 304.581 185.937 307.091 177.623 309.808L176.574 310.151C167.867 312.996 158.521 316.063 149.453 319.375C140.386 322.686 131.574 326.249 123.933 330.092C116.706 333.727 110.47 337.639 106.053 341.867C101.705 337.602 95.494 333.658 88.2676 329.997C80.6241 326.124 71.7782 322.535 62.6626 319.201C53.5453 315.867 44.1369 312.781 35.3689 309.918L34.1717 309.528C25.8536 306.813 18.1678 304.304 11.8859 301.971C1.62539 298.16 1 288.209 1 285.134L1.00008 48.767C6.70261 48.1873 12.614 45.356 18.6907 41.4191C24.5872 37.599 30.7504 32.6617 37.1361 27.546C37.7058 27.0895 38.2773 26.6317 38.8506 26.1731C52.7957 15.017 62.0424 8.76473 79.6429 6.52628C79.7038 6.68369 79.7754 6.85979 79.8582 7.05091C80.1963 7.83117 80.7287 8.87662 81.5067 9.92792C83.0656 12.0346 85.6704 14.2309 89.6775 14.2309C91.8854 14.2309 94.0591 13.3522 96.0269 12.1318C98.0033 10.9062 99.8486 9.28818 101.42 7.69702C102.995 6.10234 104.317 4.51157 105.244 3.32136C105.488 3.00856 105.705 2.72287 105.892 2.47138Z"
      fill="url(#paint0_linear_1349_2655)"
      stroke="url(#paint1_linear_1349_2655)"
      strokeWidth="2"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1349_2655"
        x1="106"
        y1="13.7578"
        x2="139"
        y2="316.758"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3D3D3D" />
        <stop offset="0.368553" stopColor="#3F3F3F" />
        <stop offset="0.968983" stopColor="#262626" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1349_2655"
        x1="51.1642"
        y1="-4.24219"
        x2="216.272"
        y2="280.509"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#333333" />
        <stop offset="1" stopColor="#2E2E2E" />
      </linearGradient>
    </defs>
  </svg>
);

export const positionOnPitch = (
  <svg
    width="100%"
    height="62.5%"
    viewBox="0 0 32 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_ii_1404_3681)">
      <ellipse cx="16" cy="10" rx="16" ry="10" fill="#545353" />
    </g>
    <defs>
      <filter
        id="filter0_ii_1404_3681"
        x="0"
        y="-0.760516"
        width="32"
        height="21.2605"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1.26753" />
        <feGaussianBlur stdDeviation="0.380258" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.75 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1404_3681"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.25" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.516667 0 0 0 0 0.516667 0 0 0 0 0.516667 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_innerShadow_1404_3681"
          result="effect2_innerShadow_1404_3681"
        />
      </filter>
    </defs>
  </svg>
);

export const selectedPlayerOnMobile = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 85 114"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 5C5.44772 5 5 5.44771 5 6V28L0 31V1C0 0.447716 0.447715 0 1 0H25L22 5H6Z"
      fill="var(--color-primary-light-blue)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M84 114C84.5523 114 85 113.552 85 113V83L80 80V108C80 108.552 79.5523 109 79 109H63L60 114H84ZM0 113C0 113.552 0.447716 114 1 114H25L22 109H6C5.44772 109 5 108.552 5 108V80L0 83V113Z"
      fill="var(--color-primary-light-blue)"
    />
    <path
      d="M63 5H79C79.5523 5 80 5.44772 80 6V31L85 34V1C85 0.447715 84.5523 0 84 0H60L63 5Z"
      fill="var(--color-primary-light-blue)"
    />
  </svg>
);

export const SquadBuilderCloseIcon = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_f_1888_19867)">
      <path
        d="M6.52941 23L3 19.4706L9.47059 13L3 6.52941L6.52941 3L13 9.47059L19.4706 3L23 6.52941L16.5294 13L23 19.4706L19.4706 23L13 16.5294L6.52941 23Z"
        fill="#392100"
      />
      <path
        d="M6.52941 23L3 19.4706L9.47059 13L3 6.52941L6.52941 3L13 9.47059L19.4706 3L23 6.52941L16.5294 13L23 19.4706L19.4706 23L13 16.5294L6.52941 23Z"
        stroke="var(--color-brand-meta-orange)"
      />
    </g>
    <path
      d="M6.52941 23L3 19.4706L9.47059 13L3 6.52941L6.52941 3L13 9.47059L19.4706 3L23 6.52941L16.5294 13L23 19.4706L19.4706 23L13 16.5294L6.52941 23Z"
      fill="#392100"
      stroke="#FFB23F"
      strokeWidth="0.5"
    />
    <defs>
      <filter
        id="filter0_f_1888_19867"
        x="0.292847"
        y="0.292847"
        width="25.4143"
        height="25.4143"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="1"
          result="effect1_foregroundBlur_1888_19867"
        />
      </filter>
    </defs>
  </svg>
);

export const suggestSquadLoadingStringsMobileTop = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 265 140"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M76.0832 2V0.5H79.0832V2H76.0832ZM77.5832 15.8071H79.0832V16.4304L78.6415 16.8701L77.5832 15.8071ZM3.05831 92.1189C2.47122 92.7033 1.52148 92.7012 0.936991 92.1142C0.352505 91.5271 0.35461 90.5773 0.941694 89.9928L3.05831 92.1189ZM85.0976 2V0.5H88.0976V2H85.0976ZM86.5976 15.8071H88.0976V16.4304L87.656 16.8701L86.5976 15.8071ZM7.91227 96.261C7.32519 96.8455 6.37544 96.8434 5.79095 96.2563C5.20647 95.6692 5.20857 94.7195 5.79566 94.135L7.91227 96.261ZM14.8465 103.165C14.2594 103.749 13.3097 103.747 12.7252 103.16C12.1407 102.573 12.1428 101.623 12.7299 101.039L14.8465 103.165ZM94.2253 22.0203H95.7253V22.6436L95.2836 23.0833L94.2253 22.0203ZM92.7253 2V0.5H95.7253V2H92.7253ZM101.74 2V0.5H104.74V2H101.74ZM103.24 22.0203H104.74V22.6436L104.298 23.0833L103.24 22.0203ZM19.7005 107.307C19.1134 107.891 18.1636 107.889 17.5792 107.302C16.9947 106.715 16.9968 105.765 17.5839 105.181L19.7005 107.307ZM53.4265 106.244C53.4265 107.072 52.7549 107.744 51.9265 107.744C51.0981 107.744 50.4265 107.072 50.4265 106.244H53.4265ZM51.9265 95.198H50.4265V94.5747L50.8682 94.135L51.9265 95.198ZM110.867 36.5178H112.367V37.141L111.926 37.5808L110.867 36.5178ZM109.367 2V0.5H112.367V2H109.367ZM118.382 2V0.5H121.382V2H118.382ZM121.382 13.7361C121.382 14.5645 120.71 15.2361 119.882 15.2361C119.054 15.2361 118.382 14.5645 118.382 13.7361H121.382ZM126.703 2V0.5H129.703V2H126.703ZM129.703 138C129.703 138.828 129.032 139.5 128.203 139.5C127.375 139.5 126.703 138.828 126.703 138H129.703ZM162.549 111.394C163.136 111.978 163.138 112.928 162.554 113.515C161.969 114.102 161.019 114.104 160.432 113.52L162.549 111.394ZM152.476 103.482L151.418 104.545L150.976 104.105V103.482H152.476ZM150.976 2V0.5H153.976V2H150.976ZM158.18 2V0.5H161.18V2H158.18ZM161.18 61.3706C161.18 62.199 160.508 62.8706 159.68 62.8706C158.851 62.8706 158.18 62.199 158.18 61.3706H161.18ZM165.808 2V0.5H168.808V2H165.808ZM167.308 51.0152L166.249 52.0782L165.808 51.6385V51.0152H167.308ZM177.709 61.3706L178.767 60.3075L179.209 60.7473V61.3706H177.709ZM179.209 129.716C179.209 130.544 178.537 131.216 177.709 131.216C176.88 131.216 176.209 130.544 176.209 129.716H179.209ZM188.223 129.716C188.223 130.544 187.552 131.216 186.723 131.216C185.895 131.216 185.223 130.544 185.223 129.716H188.223ZM186.723 61.3706L187.782 60.3075L188.223 60.7473V61.3706H186.723ZM172.855 47.5635L171.797 48.6265L171.355 48.1867V47.5635H172.855ZM171.355 2V0.5H174.355V2H171.355ZM178.289 2V0.5H181.289V2H178.289ZM179.789 45.4924L178.731 46.5554L178.289 46.1157V45.4924H179.789ZM197.818 63.4416L198.876 62.3786L199.318 62.8184V63.4416H197.818ZM199.318 129.716C199.318 130.544 198.647 131.216 197.818 131.216C196.99 131.216 196.318 130.544 196.318 129.716H199.318ZM226.362 129.716C226.362 130.544 225.69 131.216 224.862 131.216C224.033 131.216 223.362 130.544 223.362 129.716H226.362ZM224.862 70.3452L225.92 69.2822L226.362 69.7219V70.3452H224.862ZM188.11 33.7564L187.052 34.8194L186.61 34.3796V33.7564H188.11ZM186.61 2V0.5H189.61V2H186.61ZM194.931 2.69037V1.19037H197.931V2.69037H194.931ZM196.431 26.8528L195.373 27.9158L194.931 27.4761V26.8528H196.431ZM243.584 73.797L244.642 72.7339L245.084 73.1737V73.797H243.584ZM245.084 129.716C245.084 130.544 244.413 131.216 243.584 131.216C242.756 131.216 242.084 130.544 242.084 129.716H245.084ZM253.405 129.716C253.405 130.544 252.734 131.216 251.905 131.216C251.077 131.216 250.405 130.544 250.405 129.716H253.405ZM251.905 73.797L252.964 72.7339L253.405 73.1737V73.797H251.905ZM202.672 24.7817L201.614 25.8447L201.172 25.405V24.7817H202.672ZM201.172 2V0.5H204.172V2H201.172ZM208.106 2V0.5H211.106V2H208.106ZM209.606 23.401L208.548 24.464L208.106 24.0243V23.401H209.606ZM263 76.5584L264.058 75.4954L264.5 75.9351V76.5584H263ZM264.5 129.716C264.5 130.544 263.828 131.216 263 131.216C262.172 131.216 261.5 130.544 261.5 129.716H264.5ZM79.0832 2V15.8071H76.0832V2H79.0832ZM78.6415 16.8701L3.05831 92.1189L0.941694 89.9928L76.5248 14.7441L78.6415 16.8701ZM88.0976 2V15.8071H85.0976V2H88.0976ZM87.656 16.8701L7.91227 96.261L5.79566 94.135L85.5393 14.7441L87.656 16.8701ZM12.7299 101.039L93.167 20.9573L95.2836 23.0833L14.8465 103.165L12.7299 101.039ZM92.7253 22.0203V2H95.7253V22.0203H92.7253ZM104.74 2V22.0203H101.74V2H104.74ZM104.298 23.0833L19.7005 107.307L17.5839 105.181L102.182 20.9573L104.298 23.0833ZM50.4265 106.244V95.198H53.4265V106.244H50.4265ZM50.8682 94.135L109.809 35.4548L111.926 37.5808L52.9848 96.261L50.8682 94.135ZM109.367 36.5178V2H112.367V36.5178H109.367ZM121.382 2V13.7361H118.382V2H121.382ZM129.703 2V138H126.703L126.703 2H129.703ZM160.432 113.52L151.418 104.545L153.534 102.419L162.549 111.394L160.432 113.52ZM150.976 103.482L150.976 2H153.976L153.976 103.482H150.976ZM161.18 2L161.18 61.3706H158.18L158.18 2H161.18ZM168.808 2L168.808 51.0152H165.808L165.808 2H168.808ZM168.366 49.9522L178.767 60.3075L176.651 62.4336L166.249 52.0782L168.366 49.9522ZM179.209 61.3706V129.716H176.209V61.3706H179.209ZM185.223 129.716V61.3706H188.223V129.716H185.223ZM185.665 62.4336L171.797 48.6265L173.913 46.5005L187.782 60.3075L185.665 62.4336ZM171.355 47.5635L171.355 2H174.355L174.355 47.5635H171.355ZM181.289 2L181.289 45.4924H178.289L178.289 2H181.289ZM180.847 44.4294L198.876 62.3786L196.76 64.5046L178.731 46.5554L180.847 44.4294ZM199.318 63.4416V129.716H196.318V63.4416H199.318ZM223.362 129.716V70.3452H226.362V129.716H223.362ZM223.803 71.4082L187.052 34.8194L189.169 32.6933L225.92 69.2822L223.803 71.4082ZM186.61 33.7564L186.61 2H189.61L189.61 33.7564H186.61ZM197.931 2.69037L197.931 26.8528H194.931L194.931 2.69037H197.931ZM197.49 25.7898L244.642 72.7339L242.526 74.86L195.373 27.9158L197.49 25.7898ZM245.084 73.797V129.716H242.084V73.797H245.084ZM250.405 129.716V73.797H253.405V129.716H250.405ZM250.847 74.86L201.614 25.8447L203.73 23.7187L252.964 72.7339L250.847 74.86ZM201.172 24.7817L201.172 2H204.172L204.172 24.7817H201.172ZM211.106 2L211.106 23.401H208.106L208.106 2H211.106ZM210.665 22.338L264.058 75.4954L261.942 77.6214L208.548 24.464L210.665 22.338ZM264.5 76.5584V129.716H261.5V76.5584H264.5Z"
      fill="url(#paint0_linear_1888_19756)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1888_19756"
        x1="120.848"
        y1="138"
        x2="120.848"
        y2="2.00002"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.234375" stopColor="#FF7900" stopOpacity="0" />
        <stop
          offset="0.59375"
          stopColor="var(--color-brand-meta-orange)"
          stopOpacity="0.432292"
        />
        <stop offset="1" stopColor="#FFB800" />
      </linearGradient>
    </defs>
  </svg>
);

export const suggestSquadLoadingStringsMobileMid = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 183 156"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 106.151H19.0229L60.5913 147.708H174.024L180.365 154.047M180.365 135.734L174.729 130.099H57.7731L26.0684 98.4031H0M0 89.9509H33.1138L52.8413 109.673H176.138L181.774 115.308M181.774 96.9944L176.138 91.3596H51.4322L41.5685 81.4987H0M0.331741 39.3308H33.1275L70.4687 2H176.151L181.788 7.63483M49.3322 13.1307L33.1275 29.3308H0.331741M0.331741 21.5829H15.5137"
      stroke="url(#paint0_linear_1888_19758)"
      strokeWidth="3"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1888_19758"
        x1="153.5"
        y1="29.5"
        x2="-1.03142"
        y2="46.772"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.234375" stopColor="#FF7900" stopOpacity="0" />
        <stop
          offset="0.59375"
          stopColor="var(--color-brand-meta-orange)"
          stopOpacity="0.432292"
        />
        <stop offset="1" stopColor="#FFB800" />
      </linearGradient>
    </defs>
  </svg>
);

export const suggestSquadLoadingStringsMobileBottom = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 174 159"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.8"
      d="M172.405 106.287H173.905V109.287H172.405V106.287ZM144.004 107.787H142.504V106.287H144.004V107.787ZM144.004 136.208H145.504V136.846L145.045 137.288L144.004 136.208ZM122.704 156.734L123.745 157.814L123.309 158.234H122.704V156.734ZM31.9787 158.234C31.1503 158.234 30.4787 157.563 30.4787 156.734C30.4787 155.906 31.1503 155.234 31.9787 155.234V158.234ZM31.9787 151.129C31.1503 151.129 30.4787 150.458 30.4787 149.629C30.4787 148.801 31.1503 148.129 31.9787 148.129V151.129ZM117.181 149.629L118.242 150.689L117.803 151.129H117.181V149.629ZM133.748 133.05H135.248V133.671L134.81 134.111L133.748 133.05ZM133.748 102.261H132.248V101.64L132.687 101.201L133.748 102.261ZM137.693 98.3138L136.632 97.2535L137.071 96.8138H137.693V98.3138ZM172.405 96.8138H173.905V99.8138H172.405V96.8138ZM172.405 88.1296H173.905V91.1296H172.405V88.1296ZM133.748 89.6296L132.687 88.5693L133.127 88.1296H133.748V89.6296ZM128.226 95.1559H126.726V94.5349L127.165 94.0956L128.226 95.1559ZM128.226 130.682H129.726V131.303L129.287 131.742L128.226 130.682ZM117.181 141.734L118.242 142.795L117.803 143.234H117.181V141.734ZM42.2346 143.234C41.4061 143.234 40.7346 142.563 40.7346 141.734C40.7346 140.906 41.4061 140.234 42.2346 140.234V143.234ZM42.2346 137.708C41.4061 137.708 40.7346 137.037 40.7346 136.208C40.7346 135.38 41.4061 134.708 42.2346 134.708V137.708ZM107.714 136.208L108.775 137.269L108.336 137.708H107.714V136.208ZM121.915 121.998H123.415V122.619L122.976 123.058L121.915 121.998ZM121.915 85.6823H120.415V85.0613L120.854 84.622L121.915 85.6823ZM129.015 78.5771L127.954 77.5168L128.393 77.0771H129.015V78.5771ZM172.405 77.0771H173.905V80.0771H172.405V77.0771ZM172.405 67.6035H173.905V70.6035H172.405V67.6035ZM127.437 69.1035L126.376 68.0432L126.816 67.6035H127.437V69.1035ZM114.815 81.7349H113.315V81.1139L113.754 80.6747L114.815 81.7349ZM114.815 116.472H116.315V117.093L115.876 117.532L114.815 116.472ZM105.348 125.945L106.409 127.005L105.969 127.445H105.348V125.945ZM2 127.445C1.17157 127.445 0.5 126.774 0.5 125.945C0.5 125.117 1.17157 124.445 2 124.445V127.445ZM2 120.34C1.17157 120.34 0.5 119.668 0.5 118.84C0.5 118.011 1.17157 117.34 2 117.34V120.34ZM102.192 118.84L103.253 119.9L102.814 120.34H102.192V118.84ZM107.714 113.314H109.214V113.935L108.775 114.374L107.714 113.314ZM107.714 20.9459H106.214V20.3249L106.653 19.8857L107.714 20.9459ZM117.181 11.4723L116.12 10.412L116.56 9.97231H117.181V11.4723ZM172.405 9.97231H173.905V12.9723H172.405V9.97231ZM172.405 59.7088H173.905V62.7088H172.405V59.7088ZM117.181 62.7088C116.353 62.7088 115.681 62.0372 115.681 61.2088C115.681 60.3804 116.353 59.7088 117.181 59.7088V62.7088ZM117.181 54.0246C116.353 54.0246 115.681 53.3531 115.681 52.5246C115.681 51.6962 116.353 51.0246 117.181 51.0246V54.0246ZM172.405 51.0246H173.905V54.0246H172.405V51.0246ZM172.405 41.551H173.905V44.551H172.405V41.551ZM117.181 44.551C116.353 44.551 115.681 43.8795 115.681 43.051C115.681 42.2226 116.353 41.551 117.181 41.551V44.551ZM117.181 37.4458C116.353 37.4458 115.681 36.7742 115.681 35.9458C115.681 35.1174 116.353 34.4458 117.181 34.4458V37.4458ZM172.405 34.4458H173.905V37.4458H172.405V34.4458ZM133.748 27.9722C132.92 27.9722 132.248 27.3006 132.248 26.4722C132.248 25.6438 132.92 24.9722 133.748 24.9722V27.9722ZM172.405 24.9722H173.905V27.9722H172.405V24.9722ZM140.06 3.4987C139.231 3.4987 138.56 2.82713 138.56 1.9987C138.56 1.17027 139.231 0.498703 140.06 0.498703V3.4987ZM172.405 0.498703H173.905V3.4987H172.405V0.498703ZM172.405 109.287H144.004V106.287H172.405V109.287ZM145.504 107.787V136.208H142.504V107.787H145.504ZM145.045 137.288L123.745 157.814L121.663 155.654L142.963 135.128L145.045 137.288ZM122.704 158.234H31.9787V155.234H122.704V158.234ZM31.9787 148.129H117.181V151.129H31.9787V148.129ZM116.12 148.569L132.687 131.99L134.81 134.111L118.242 150.689L116.12 148.569ZM132.248 133.05V102.261H135.248V133.05H132.248ZM132.687 101.201L136.632 97.2535L138.754 99.3741L134.81 103.321L132.687 101.201ZM137.693 96.8138H172.405V99.8138H137.693V96.8138ZM172.405 91.1296H133.748V88.1296H172.405V91.1296ZM134.81 90.6899L129.287 96.2162L127.165 94.0956L132.687 88.5693L134.81 90.6899ZM129.726 95.1559V130.682H126.726V95.1559H129.726ZM129.287 131.742L118.242 142.795L116.12 140.674L127.165 129.622L129.287 131.742ZM117.181 143.234H42.2346V140.234H117.181V143.234ZM42.2346 134.708H107.714V137.708H42.2346V134.708ZM106.653 135.148L120.854 120.938L122.976 123.058L108.775 137.269L106.653 135.148ZM120.415 121.998V85.6823H123.415V121.998H120.415ZM120.854 84.622L127.954 77.5168L130.076 79.6374L122.976 86.7426L120.854 84.622ZM129.015 77.0771H172.405V80.0771H129.015V77.0771ZM172.405 70.6035H127.437V67.6035H172.405V70.6035ZM128.498 70.1637L115.876 82.7952L113.754 80.6747L126.376 68.0432L128.498 70.1637ZM116.315 81.7349V116.472H113.315V81.7349H116.315ZM115.876 117.532L106.409 127.005L104.287 124.885L113.754 115.411L115.876 117.532ZM105.348 127.445H2V124.445H105.348V127.445ZM2 117.34H102.192V120.34H2V117.34ZM101.131 117.78L106.653 112.253L108.775 114.374L103.253 119.9L101.131 117.78ZM106.214 113.314V20.9459H109.214V113.314H106.214ZM106.653 19.8857L116.12 10.412L118.242 12.5326L108.775 22.0062L106.653 19.8857ZM117.181 9.97231H172.405V12.9723H117.181V9.97231ZM172.405 62.7088H117.181V59.7088H172.405V62.7088ZM117.181 51.0246H172.405V54.0246H117.181V51.0246ZM172.405 44.551H117.181V41.551H172.405V44.551ZM117.181 34.4458H172.405V37.4458H117.181V34.4458ZM133.748 24.9722H172.405V27.9722H133.748V24.9722ZM140.06 0.498703H172.405V3.4987H140.06V0.498703Z"
      fill="url(#paint0_linear_1888_19757)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1888_19757"
        x1="68.5"
        y1="11"
        x2="172"
        y2="55.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.234375" stopColor="#FF7900" stopOpacity="0" />
        <stop
          offset="0.59375"
          stopColor="var(--color-brand-meta-orange)"
          stopOpacity="0.432292"
        />
        <stop offset="1" stopColor="#FFB800" />
      </linearGradient>
    </defs>
  </svg>
);

export const FC24PositionOnPitch = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 210 97"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_i_2015_29013)">
      <path
        d="M0 0.828125H210V57.8281C210 79.3672 192.539 96.8281 171 96.8281H39C17.4609 96.8281 0 79.3672 0 57.8281V0.828125Z"
        fill="#D9D9D9"
      />
      <path
        d="M0 0.828125H210V57.8281C210 79.3672 192.539 96.8281 171 96.8281H39C17.4609 96.8281 0 79.3672 0 57.8281V0.828125Z"
        fill="#D9D9D9"
      />
      <path
        d="M0 0.828125H210V57.8281C210 79.3672 192.539 96.8281 171 96.8281H39C17.4609 96.8281 0 79.3672 0 57.8281V0.828125Z"
        fill="#424242"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_2015_29013"
        x="0"
        y="-3.73497"
        width="210"
        height="100.563"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-7.60516" />
        <feGaussianBlur stdDeviation="2.28155" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.75 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_2015_29013"
        />
      </filter>
    </defs>
  </svg>
);

export const playerSlot = (
  <svg
    width="74"
    height="105"
    viewBox="0 0 74 105"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_6007_1353)">
      <path
        d="M50.4251 45.1634V50.2453H40.2577V60.4095H35.1758V50.2453H25.0157V45.1634H35.1758V35H40.2577V45.1634H50.4251Z"
        fill="var(--fillCross)" // TODO: figure out what this is
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.092 95L63.3948 88.6231C67.0127 87.5015 67.0127 84.5082 67.0127 80.237V9.28305C43.741 2.26376 29.7584 2.21425 7.02459 9.28305V80.2195C7.02378 80.6648 7.01762 81.0962 7.01167 81.5131C6.96045 85.1038 6.92461 87.6168 10.4469 88.6231L37.092 95ZM50.4251 50.2453V45.1634H40.2577V35H35.1758V45.1634H25.0157V50.2453H35.1758V60.4095H40.2577V50.2453H50.4251Z"
        fill="var(--fillBackground)" // TODO: figure out what this is
      />
    </g>
    <defs>
      <linearGradient
        id="notHovered"
        x1="16.5"
        y1="4"
        x2="63.5"
        y2="95"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#383838" />
        <stop offset="1" stopColor="#454545" />
      </linearGradient>
      <linearGradient
        id="hovered"
        x1="36.0064"
        y1="6"
        x2="36.0064"
        y2="97"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1D1D1D" />
        <stop offset="1" stopColor="#232323" />
      </linearGradient>
    </defs>
  </svg>
);

export const playerSlotWithoutHover = (
  <svg
    width="74"
    height="105"
    viewBox="0 0 74 105"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_5873_2186)">
      <path
        d="M63.3792 88.6231L37.0763 95L10.4312 88.6231C6.5 87.5 7.00107 84.5 7.00893 80.2195V9.28305C29.7428 2.21425 43.7253 2.26376 66.997 9.28305V80.2195V80.237C66.997 84.5082 66.997 87.5015 63.3792 88.6231Z"
        fill="url(#paint0_linear_5873_2186)"
        fillOpacity="0.42"
      />
      <path
        d="M63.3792 88.6231L37.0763 95L10.4312 88.6231C6.5 87.5 7.00107 84.5 7.00893 80.2195V9.28305C29.7428 2.21425 43.7253 2.26376 66.997 9.28305V80.2195V80.237C66.997 84.5082 66.997 87.5015 63.3792 88.6231Z"
        fill="black"
        fillOpacity="0.42"
      />
    </g>
    <rect x="25" y="45.1631" width="25.4095" height="5.08189" fill="#111111" />
    <rect
      x="35.1602"
      y="60.4092"
      width="25.4095"
      height="5.08189"
      transform="rotate(-90 35.1602 60.4092)"
      fill="#111111"
    />
    <defs>
      <filter
        id="filter0_d_5873_2186"
        x="0.484375"
        y="0.5"
        width="73.0117"
        height="104"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3" />
        <feGaussianBlur stdDeviation="3.25" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.91 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5873_2186"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5873_2186"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_5873_2186"
        x1="-0.799998"
        y1="-65.16"
        x2="125.876"
        y2="104.79"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#7A7A7A" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
    </defs>
  </svg>
);

export const includeExcludePlayer = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 104 110"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 0H104V61H94V10H10V100H54V110H0V0Z" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 91C20.5358 66.0489 25.4393 57.9418 40.2556 51.3155C40.2556 51.3155 32.5216 40.8616 33.6416 33.5401C35.1111 23.9331 42.5242 16.7867 52.2405 17.0049C61.7198 17.2177 68.5034 24.1803 70.0191 33.5401C71.1942 40.7975 63.8183 51.3155 63.8183 51.3155C69.8329 54.0243 74.0837 57.0701 77.085 61H69.5H54V70.5V91H20Z"
      fill="url(#paint0_linear_6669_17675)"
    />
    <path d="M54 61V70.5L69.5 61H54Z" fill="url(#paint1_linear_6669_17675)" />
    <path
      d="M54 91H84.074C83.6509 76.7484 82.1407 67.6199 77.085 61H69.5L54 70.5V91Z"
      fill="url(#paint2_linear_6669_17675)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6669_17675"
        x1="25.5"
        y1="24"
        x2="87.5"
        y2="93"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.422536" stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_6669_17675"
        x1="25.5"
        y1="24"
        x2="87.5"
        y2="93"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.422536" stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_6669_17675"
        x1="25.5"
        y1="24"
        x2="87.5"
        y2="93"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.422536" stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);
